// src/components/EmployeeDetails.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../config";
import "./EmployeeDetails.css";

// Import React Icons
import { 
  FiUsers, FiRefreshCw, FiArrowLeft, FiEdit, FiGrid, FiSearch,
  FiUser, FiMail, FiPhone, FiCalendar, FiUserCheck, FiBriefcase,
  FiFolder, FiMapPin, FiClock, FiCheckCircle, FiAlertCircle,
  FiFileText, FiDownload, FiUpload, FiEye, FiX, FiDollarSign,FiMonitor,FiCheck,
  FiGlobe, FiDroplet, FiBarChart, FiArchive, FiCamera, FiDatabase,
  FiMessageSquare, FiPaperclip, FiStar,FiTool, FiXCircle, FiAlertTriangle, FiInfo,FiTarget
} from "react-icons/fi";
import { 
  FaTransgender, FaIdCard, FaBuilding, FaMapMarkerAlt, FaChartBar,
  FaGraduationCap,FaFilePdf, FaFileImage,FaBook,
  FaFileWord, FaFileExcel, FaFileAlt, FaPassport,
  FaStethoscope, FaCar, FaUniversity, FaCertificate
} from "react-icons/fa";

const EmployeeDetails = ({ onBack }) => {
  const navigate = useNavigate();

  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  
  // Employee details data
  const [leaveData, setLeaveData] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [timesheetData, setTimesheetData] = useState([]);
  const [personalData, setPersonalData] = useState(null);
  const [academicData, setAcademicData] = useState([]);
  const [experienceData, setExperienceData] = useState([]);
  const [documentData, setDocumentData] = useState([]);
  const [taskData, setTaskData] = useState([]); // ✅ ADDED TASK DATA
  
  const [activeTab, setActiveTab] = useState("basic");
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [employeeProfilePics, setEmployeeProfilePics] = useState({});

  // NEW: Store emp_id and employeeName from fetchEmployeeDetails
  const [currentEmpId, setCurrentEmpId] = useState("");
  const [currentEmployeeName, setCurrentEmployeeName] = useState("");

  // Photo modal states
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState('');
  const [photoTitle, setPhotoTitle] = useState('');

  const [taskeSelectedTask, setTaskeSelectedTask] = useState(null);
  const [taskeShowModal, setTaskeShowModal] = useState(false);

  const handleTaskeViewClick = (task) => {
    setTaskeSelectedTask(task);
    setTaskeShowModal(true);
  };

  const handleTaskeCloseModal = () => {
    setTaskeShowModal(false);
    setTaskeSelectedTask(null);
  };

  const [leaveSelectedLeave, setLeaveSelectedLeave] = useState(null);
  const [leaveShowModal, setLeaveShowModal] = useState(false);
  const [leaveFilter, setLeaveFilter] = useState('all');

  const handleLeaveViewClick = (leave) => {
    setLeaveSelectedLeave(leave);
    setLeaveShowModal(true);
  };

  const handleLeaveCloseModal = () => {
    setLeaveShowModal(false);
    setLeaveSelectedLeave(null);
  };

  // Helper functions
  const formatDatess = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getLeaveTypeColor = (type) => {
    const leaveType = (type || 'General').toLowerCase();
    switch (leaveType) {
      case 'casual': return '#ff9800';
      case 'sick': return '#f44336';
      case 'annual': return '#4caf50';
      case 'maternity': return '#9c27b0';
      case 'paternity': return '#2196f3';
      case 'emergency': return '#ff5722';
      case 'unpaid': return '#795548';
      default: return '#607d8b';
    }
  };

  const getStatusColors = (status) => {
    switch (status?.toLowerCase()) {
      case 'approved': return '#4caf50';
      case 'pending': return '#ff9800';
      case 'rejected': return '#f44336';
      case 'cancelled': return '#9e9e9e';
      default: return '#757575';
    }
  };

  // Calculate statistics
  const approvedCount = leaveData.filter(l => l.status === 'Approved').length;
  const pendingCountss = leaveData.filter(l => l.status === 'Pending').length;
  const rejectedCountss = leaveData.filter(l => l.status === 'Rejected').length;
  const totalDays = leaveData.reduce((total, leave) => total + (leave.leaveDays || leave.totalDays || 0), 0);

  // Filter leaves based on status
  const filteredLeaves = leaveData.filter(leave => {
    if (leaveFilter === 'all') return true;
    return leave.status?.toLowerCase() === leaveFilter;
  });

  // Calculate upcoming leaves
  const upcomingLeaves = leaveData.filter(leave => {
    if (leave.status !== 'Approved') return false;
    const startDate = new Date(leave.startDate);
    const today = new Date();
    return startDate >= today;
  });

  const [attendSelectedRecord, setAttendSelectedRecord] = useState(null);
  const [attendShowModal, setAttendShowModal] = useState(false);
  const [attendShowPhotoModal, setAttendShowPhotoModal] = useState(false);
  const [attendSelectedPhoto, setAttendSelectedPhoto] = useState(null);
  const [attendPhotoTitle, setAttendPhotoTitle] = useState("");
  const [attendFilter, setAttendFilter] = useState('all');

  const handleAttendViewClick = (record) => {
    setAttendSelectedRecord(record);
    setAttendShowModal(true);
  };

  const handleAttendCloseModal = () => {
    setAttendShowModal(false);
    setAttendSelectedRecord(null);
  };

  const handleAttendViewPhoto = (photoData, title) => {
    setAttendSelectedPhoto(photoData);
    setAttendPhotoTitle(title);
    setAttendShowPhotoModal(true);
  };

  const handleAttendClosePhotoModal = () => {
    setAttendShowPhotoModal(false);
    setAttendSelectedPhoto(null);
    setAttendPhotoTitle("");
  };

  // Helper functions
  const getAttendanceStatus = (record) => {
    if (record.punchIn && record.punchOut) {
      return "Present";
    } else if (record.punchIn && !record.punchOut) {
      return "Pending";
    }
    return "Absent";
  };

  const formatLocation = (location) => {
    if (!location) return "N/A";
    if (typeof location === 'string') return location;
    if (typeof location === 'object') {
      if (location.lat && location.lng) {
        return `${location.lat.toFixed(6)}, ${location.lng.toFixed(6)}`;
      }
      if (location.address) return location.address;
      return "Location Data";
    }
    return "N/A";
  };

  const formatDates = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const formatTime = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  const calculateDurations = (punchIn, punchOut) => {
    if (!punchIn || !punchOut) return "N/A";
    const start = new Date(punchIn);
    const end = new Date(punchOut);
    const diffMs = end - start;
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    return `${hours}h ${minutes}m`;
  };

  // Filter attendance records
  const filteredAttendance = attendanceData.filter(record => {
    if (attendFilter === 'all') return true;
    const status = getAttendanceStatus(record).toLowerCase();
    return status === attendFilter;
  });

  // Statistics
  const presentCount = attendanceData.filter(record => getAttendanceStatus(record) === 'Present').length;
  const pendingCounts = attendanceData.filter(record => getAttendanceStatus(record) === 'Pending').length;
  const absentCount = attendanceData.filter(record => getAttendanceStatus(record) === 'Absent').length;

  const [timshSelectedSheet, setTimshSelectedSheet] = useState(null);
  const [timshShowModal, setTimshShowModal] = useState(false);
  const [timshFilter, setTimshFilter] = useState('all');

  const handleTimshViewClick = (timesheet) => {
    setTimshSelectedSheet(timesheet);
    setTimshShowModal(true);
  };

  const handleTimshCloseModal = () => {
    setTimshShowModal(false);
    setTimshSelectedSheet(null);
  };

  // Filter timesheets based on status
  const filteredTimesheets = timesheetData.filter(sheet => {
    if (timshFilter === 'all') return true;
    return sheet.status?.toLowerCase() === timshFilter;
  });

  // Calculate statistics
  const totalHours = timesheetData.reduce((total, sheet) => total + (parseFloat(sheet.hours) || 0), 0);
  const completedCount = timesheetData.filter(sheet => sheet.status === 'Completed').length;
  const pendingCount = timesheetData.filter(sheet => sheet.status === 'Pending').length;
  const rejectedCount = timesheetData.filter(sheet => sheet.status === 'Rejected').length;

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'completed': return '#4caf50';
      case 'approved': return '#4caf50';
      case 'pending': return '#ff9800';
      case 'submitted': return '#2196f3';
      case 'rejected': return '#f44336';
      case 'draft': return '#9e9e9e';
      default: return '#757575';
    }
  };

  const [docuiSelectedDoc, setDocuiSelectedDoc] = useState(null);
  const [docuiShowModal, setDocuiShowModal] = useState(false);

  const handleDocuiViewClick = (document) => {
    setDocuiSelectedDoc(document);
    setDocuiShowModal(true);
  };

  const handleDocuiCloseModal = () => {
    setDocuiShowModal(false);
    setDocuiSelectedDoc(null);
  };

  // Helper functions
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatFileSize = (bytes) => {
    if (!bytes || bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const getDocumentIcon = (doc) => {
    if (doc.contentType) {
      if (doc.contentType.includes('pdf')) return <FaFilePdf />;
      if (doc.contentType.includes('image')) return <FaFileImage />;
      if (doc.contentType.includes('word')) return <FaFileWord />;
      if (doc.contentType.includes('excel')) return <FaFileExcel />;
      if (doc.contentType.includes('text')) return <FaFileAlt />;
    }
    
    const docName = doc.name?.toLowerCase() || '';
    if (docName.includes('aadhaar') || docName.includes('pan')) return <FaIdCard />;
    if (docName.includes('marksheet') || docName.includes('certificate')) return <FaCertificate />;
    if (docName.includes('photo') || docName.includes('picture')) return <FaFileImage />;
    if (docName.includes('resume') || docName.includes('cv')) return <FaFileAlt />;
    if (docName.includes('letter') || docName.includes('offer')) return <FaFileAlt />;
    if (docName.includes('passport')) return <FaPassport />;
    if (docName.includes('bank') || docName.includes('statement')) return <FaBuilding />;
    if (docName.includes('medical') || docName.includes('health')) return <FaStethoscope />;
    if (docName.includes('license') || docName.includes('driving')) return <FaCar />;
    return <FaFileAlt />;
  };

  const getDocumentColor = (doc) => {
    const docName = doc.name?.toLowerCase() || '';
    if (docName.includes('aadhaar') || docName.includes('pan') || docName.includes('id')) return '#ff6b6b';
    if (docName.includes('resume') || docName.includes('cv')) return '#4ecdc4';
    if (docName.includes('marksheet') || docName.includes('certificate')) return '#45b7d1';
    if (docName.includes('photo')) return '#96ceb4';
    if (docName.includes('letter') || docName.includes('offer')) return '#feca57';
    if (docName.includes('bank') || docName.includes('statement')) return '#ff9ff3';
    if (docName.includes('medical')) return '#1dd1a1';
    if (docName.includes('license')) return '#54a0ff';
    return '#c62828';
  };

  const getFileType = (contentType, filename) => {
    if (contentType) {
      if (contentType.includes('pdf')) return 'PDF';
      if (contentType.includes('image')) return 'Image';
      if (contentType.includes('word')) return 'Word';
      if (contentType.includes('excel')) return 'Excel';
      if (contentType.includes('text')) return 'Text';
    }
    
    const ext = filename?.split('.').pop()?.toLowerCase();
    if (ext === 'pdf') return 'PDF';
    if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(ext)) return 'Image';
    if (['doc', 'docx'].includes(ext)) return 'Word';
    if (['xls', 'xlsx'].includes(ext)) return 'Excel';
    if (['txt', 'rtf'].includes(ext)) return 'Text';
    return 'File';
  };

  const [expriSelectedExp, setExpriSelectedExp] = useState(null);
  const [expriShowModal, setExpriShowModal] = useState(false);

  const handleExpriViewClick = (experience) => {
    setExpriSelectedExp(experience);
    setExpriShowModal(true);
  };

  const handleExpriCloseModal = () => {
    setExpriShowModal(false);
    setExpriSelectedExp(null);
  };

  // Calculate total experience
  const calculateTotalExperience = () => {
    if (experienceData.length === 0) return "0 years";
    
    let totalMonths = 0;
    
    experienceData.forEach(exp => {
      const startDate = new Date(exp.startDate);
      const endDate = exp.endDate ? new Date(exp.endDate) : new Date();
      
      const years = endDate.getFullYear() - startDate.getFullYear();
      const months = endDate.getMonth() - startDate.getMonth();
      
      totalMonths += (years * 12) + months;
    });
    
    const years = Math.floor(totalMonths / 12);
    const months = totalMonths % 12;
    
    if (years === 0) return `${months} month${months !== 1 ? 's' : ''}`;
    if (months === 0) return `${years} year${years !== 1 ? 's' : ''}`;
    return `${years} year${years !== 1 ? 's' : ''} ${months} month${months !== 1 ? 's' : ''}`;
  };

  const calculateDuration = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    
    const years = end.getFullYear() - start.getFullYear();
    const months = end.getMonth() - start.getMonth();
    
    let totalMonths = (years * 12) + months;
    
    // Adjust for days
    if (end.getDate() < start.getDate()) {
      totalMonths--;
    }
    
    const yearCount = Math.floor(totalMonths / 12);
    const monthCount = totalMonths % 12;
    
    if (yearCount === 0) return `${monthCount} month${monthCount !== 1 ? 's' : ''}`;
    if (monthCount === 0) return `${yearCount} year${yearCount !== 1 ? 's' : ''}`;
    return `${yearCount} year${yearCount !== 1 ? 's' : ''} ${monthCount} month${monthCount !== 1 ? 's' : ''}`;
  };

  // Helper function to calculate age
  const calculateAge = (birthDate) => {
    if (!birthDate) return 'N/A';
    const today = new Date();
    const birth = new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    
    return age;
  };

  // Fetch employees list
  useEffect(() => {
    fetchEmployees();
  }, []);

  // Fetch selected employee details
  useEffect(() => {
    if (selectedEmployee?._id) {
      fetchEmployeeDetails(selectedEmployee._id);
    }
  }, [selectedEmployee]);

  // Helper functions for academic component
  const getLevelClass = (qualification) => {
    const qual = qualification?.toLowerCase() || '';
    if (qual.includes('phd') || qual.includes('doctorate')) return 'doctoral';
    if (qual.includes('master') || qual.includes('m.') || qual.includes('mba')) return 'masters';
    if (qual.includes('bachelor') || qual.includes('b.') || qual.includes('b tech')) return 'bachelors';
    if (qual.includes('diploma')) return 'diploma';
    if (qual.includes('higher secondary') || qual.includes('12th')) return 'secondary';
    if (qual.includes('secondary') || qual.includes('10th')) return 'secondary';
    return 'other';
  };

  const getLevelText = (qualification) => {
    const qual = qualification?.toLowerCase() || '';
    if (qual.includes('phd') || qual.includes('doctorate')) return 'Doctoral';
    if (qual.includes('master') || qual.includes('m.') || qual.includes('mba')) return "Master's";
    if (qual.includes('bachelor') || qual.includes('b.') || qual.includes('b tech')) return "Bachelor's";
    if (qual.includes('diploma')) return 'Diploma';
    if (qual.includes('higher secondary') || qual.includes('12th')) return 'Higher Secondary';
    if (qual.includes('secondary') || qual.includes('10th')) return 'Secondary';
    return 'Other';
  };

  const fetchEmployees = async () => {
    try {
      setLoading(true);
      const token = sessionStorage.getItem("token");
      const company = sessionStorage.getItem("companyName") || 
                     JSON.parse(sessionStorage.getItem("userData") || "{}")?.company;
      
      if (!token || !company) return;

      const response = await fetch(
        `${API_BASE_URL}/api/employees/company/${encodeURIComponent(company)}`,
        {
          headers: { 
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      if (response.ok) {
        const data = await response.json();
        const employeesArray = Array.isArray(data) ? data : [];
        setEmployees(employeesArray);
        
        // Fetch profile pictures for all employees
        fetchEmployeeProfilePics(employeesArray, token);
      }
    } catch (error) {
      console.error("Error fetching employees:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchEmployeeProfilePics = async (employees, token) => {
    try {
      const profilePicMap = {};
      
      // Fetch profile pictures in parallel
      const profilePromises = employees.map(async (emp) => {
        try {
          // Check if employee already has profile picture data
          if (emp.profilePicture || emp.profilePic || emp.photo) {
            const profilePic = emp.profilePicture || emp.profilePic || emp.photo;
            // Convert relative URL to absolute URL if needed
            if (profilePic && !profilePic.startsWith('http') && !profilePic.startsWith('data:')) {
              profilePicMap[emp._id] = `${API_BASE_URL}${profilePic}`;
            } else if (profilePic) {
              profilePicMap[emp._id] = profilePic;
            }
            return; // Skip API call if we already have the picture
          }
          
          // If not in employee data, try to fetch from profile API
          const profileResponse = await fetch(
            `${API_BASE_URL}/api/profiles/${emp._id}`,
            {
              headers: { 
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
              }
            }
          );
          
          if (profileResponse.ok) {
            const profileData = await profileResponse.json();
            console.log(`Profile data for ${emp.name}:`, profileData);
            
            // Check for profile picture in profile data
            const profilePic = 
              profileData.profilePic || 
              profileData.profilePicture || 
              profileData.photo ||
              profileData.avatar;
            
            if (profilePic) {
              // Convert relative URL to absolute URL if needed
              if (!profilePic.startsWith('http') && !profilePic.startsWith('data:')) {
                profilePicMap[emp._id] = `${API_BASE_URL}${profilePic}`;
              } else {
                profilePicMap[emp._id] = profilePic;
              }
              console.log(`✅ Found profile picture for ${emp.name}`);
            } else {
              console.log(`❌ No profile picture found for ${emp.name}`);
            }
          } else if (profileResponse.status === 404) {
            console.log(`ℹ️ No profile exists yet for ${emp.name}`);
          } else {
            console.log(`❌ Profile API error for ${emp.name}: ${profileResponse.status}`);
          }
        } catch (err) {
          console.log(`Could not fetch profile for ${emp.name}:`, err.message);
        }
      });
      
      await Promise.all(profilePromises);
      console.log('Profile pictures fetched:', profilePicMap);
      setEmployeeProfilePics(profilePicMap);
      
    } catch (error) {
      console.error("Error fetching profile pictures:", error);
    }
  };

  // View photo function
  const viewPhoto = (photoData, title) => {
    setSelectedPhoto(photoData);
    setPhotoTitle(title);
    setShowPhotoModal(true);
  };

  const fetchEmployeeDetails = async (employeeId) => {
    if (!employeeId) return;
    
    setLoadingDetails(true);
    
    try {
      const token = sessionStorage.getItem("token");
      const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
      const company = userData?.company || sessionStorage.getItem("companyName");
      
      const headers = {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      };

      console.log(`🔍 Fetching details for employee: ${employeeId}`);
      console.log(`🏢 Company: ${company}`);

      // 1️⃣ FIRST: Fetch employee details to get both IDs
      let emp_id = employeeId;
      let employeeName = "";
      let employeeData = null;
      let isMongoId = /^[0-9a-fA-F]{24}$/.test(employeeId);
      
      console.log(`📊 Input ID type: ${isMongoId ? 'MongoDB ObjectId' : 'Custom emp_id'}`);
      
      try {
        let employeeResponse;
        
        if (isMongoId) {
          // It's a MongoDB ID, fetch by ID
          employeeResponse = await fetch(
            `${API_BASE_URL}/api/employees/${employeeId}`,
            { headers }
          );
        } else {
          // It's a custom emp_id, try to find employee
          employeeResponse = await fetch(
            `${API_BASE_URL}/api/employees/emp_id/${employeeId}`,
            { headers }
          );
          
          // If emp_id endpoint doesn't exist, try search
          if (!employeeResponse.ok) {
            employeeResponse = await fetch(
              `${API_BASE_URL}/api/employees/search?emp_id=${employeeId}`,
              { headers }
            );
          }
        }
        
        if (employeeResponse.ok) {
          employeeData = await employeeResponse.json();
          console.log("Employee data:", employeeData);
          
          // Handle different response formats
          if (employeeData.data) {
            employeeData = employeeData.data;
          }
          
          if (Array.isArray(employeeData) && employeeData.length > 0) {
            employeeData = employeeData[0];
          }
          
          if (employeeData.emp_id) {
            emp_id = employeeData.emp_id;
            employeeName = employeeData.name || "";
            console.log(`✅ Found employee: ${employeeName} (emp_id: ${emp_id})`);
          } else {
            console.log(`⚠️ Employee data doesn't have emp_id field`);
          }
          
          // Get MongoDB ID if we don't have it
          if (!isMongoId && employeeData._id) {
            employeeId = employeeData._id;
            console.log(`🔄 Using MongoDB ID: ${employeeId}`);
          }
        } else {
          console.log(`❌ Could not fetch employee details: ${employeeResponse.status}`);
        }
      } catch (err) {
        console.log("Could not fetch employee details:", err);
      }

      // Save emp_id and employeeName to state
      setCurrentEmpId(emp_id);
      setCurrentEmployeeName(employeeName || selectedEmployee?.name || "");

      // 2️⃣ Fetch PERSONAL INFO using emp_id
      let personalInfo = null;

      if (emp_id) {
        try {
          console.log(`🔍 Fetching personal info for emp_id: ${emp_id}`);
          const personalResponse = await fetch(
            `${API_BASE_URL}/api/personal-info/emp_id/${emp_id}`,
            { headers }
          );
          
          if (personalResponse.ok) {
            const result = await personalResponse.json();
            console.log("Personal info API response:", result);
            
            if (result.success && result.data) {
              personalInfo = result.data;
              console.log(`✅ Personal info found for ${employeeName}`);
            } else {
              console.log(`❌ Personal info not found: ${result.message}`);
            }
          } else {
            console.log(`❌ Personal info API error: ${personalResponse.status}`);
          }
        } catch (err) {
          console.log("Personal info fetch error:", err);
        }
      }

      if (personalInfo) {
        setPersonalData(personalInfo);
      } else {
        setPersonalData(null);
        console.log(`⚠️ No personal info found for emp_id: ${emp_id}`);
      }

      // 3️⃣ Fetch LEAVE data
      let leaveDataArray = [];
      
      // Try different endpoints for leave
      const leaveEndpoints = [
        `${API_BASE_URL}/api/leave/employee/${emp_id}`,
        `${API_BASE_URL}/api/leave?employeeId=${emp_id}`,
        `${API_BASE_URL}/api/leave?employeeId=${employeeId}`,
        `${API_BASE_URL}/api/leave/employee/${employeeId}`,
      ];

      for (const endpoint of leaveEndpoints) {
        if (leaveDataArray.length > 0) break;
        
        try {
          console.log(`Trying leave endpoint: ${endpoint}`);
          const response = await fetch(endpoint, { headers });
          
          if (response.ok) {
            const data = await response.json();
            console.log("Leave response from", endpoint, ":", data);
            
            // Handle different response formats
            if (Array.isArray(data)) {
              leaveDataArray = data;
            } else if (data.leaveRequests && Array.isArray(data.leaveRequests)) {
              leaveDataArray = data.leaveRequests;
            } else if (data.data && Array.isArray(data.data)) {
              leaveDataArray = data.data;
            } else if (data.leaves && Array.isArray(data.leaves)) {
              leaveDataArray = data.leaves;
            } else if (data.success && Array.isArray(data.data)) {
              leaveDataArray = data.data;
            }
            
            if (leaveDataArray.length > 0) {
              console.log(`✅ Found ${leaveDataArray.length} leaves from ${endpoint}`);
              break;
            }
          } else {
            console.log(`❌ Endpoint ${endpoint} failed: ${response.status}`);
          }
        } catch (err) {
          console.log(`🚫 Endpoint ${endpoint} error:`, err.message);
        }
      }

      // If still no leave data, try company endpoint and filter
      if (leaveDataArray.length === 0 && company) {
        try {
          console.log(`Trying company endpoint for ${company}`);
          const companyResponse = await fetch(
            `${API_BASE_URL}/api/leave/company/${company}`,
            { headers }
          );
          
          if (companyResponse.ok) {
            const companyData = await companyResponse.json();
            console.log("Company leave data response:", companyData);
            
            let allLeaves = [];
            
            if (companyData.leaveRequests && Array.isArray(companyData.leaveRequests)) {
              allLeaves = companyData.leaveRequests;
            } else if (Array.isArray(companyData)) {
              allLeaves = companyData;
            } else if (companyData.data && Array.isArray(companyData.data)) {
              allLeaves = companyData.data;
            } else if (companyData.success && Array.isArray(companyData.data)) {
              allLeaves = companyData.data;
            }
            
            // Filter for this specific employee
            if (allLeaves.length > 0) {
              leaveDataArray = allLeaves.filter(leave => {
                const leaveEmpId = leave.emp_id || leave.employeeId || 
                                  (leave.employee && leave.employee.emp_id) ||
                                  (leave.employee && leave.employee._id);
                return leaveEmpId === emp_id || leaveEmpId === employeeId;
              });
              
              console.log(`✅ Filtered ${leaveDataArray.length} leaves from company data`);
            }
          }
        } catch (err) {
          console.log("Company endpoint error:", err);
        }
      }

      console.log(`📊 Final leave data count: ${leaveDataArray.length}`);
      setLeaveData(leaveDataArray);

      // 4️⃣ Fetch ATTENDANCE data
      let attendanceDataArray = [];

      // Try different endpoints for attendance
      const attendanceEndpoints = [
        `${API_BASE_URL}/api/attendance?emp_id=${emp_id}`,
        `${API_BASE_URL}/api/attendance?employeeId=${emp_id}`,
        `${API_BASE_URL}/api/attendance?employeeId=${employeeId}`,
        `${API_BASE_URL}/api/attendance/employee/${emp_id}`,
        `${API_BASE_URL}/api/attendance/employee/${employeeId}`,
      ];

      for (const endpoint of attendanceEndpoints) {
        if (attendanceDataArray.length > 0) break;
        
        try {
          console.log(`Trying attendance endpoint: ${endpoint}`);
          const response = await fetch(endpoint, { headers });
          
          if (response.ok) {
            const data = await response.json();
            console.log("Attendance response from", endpoint, ":", data);
            
            // Handle different response formats
            if (data.success && Array.isArray(data.data)) {
              attendanceDataArray = data.data;
            } else if (Array.isArray(data)) {
              attendanceDataArray = data;
            } else if (data.data && Array.isArray(data.data)) {
              attendanceDataArray = data.data;
            } else if (data.attendance && Array.isArray(data.attendance)) {
              attendanceDataArray = data.attendance;
            }
            
            if (attendanceDataArray.length > 0) {
              console.log(`✅ Found ${attendanceDataArray.length} attendance records from ${endpoint}`);
              break;
            }
          } else {
            console.log(`❌ Endpoint ${endpoint} failed: ${response.status}`);
          }
        } catch (err) {
          console.log(`Attendance endpoint error:`, err.message);
        }
      }

      console.log(`📊 Final attendance data count: ${attendanceDataArray.length}`);
      if (attendanceDataArray.length > 0) {
        console.log(`📊 Sample attendance record:`, attendanceDataArray[0]);
      } else {
        console.log(`⚠️ No attendance records found`);
      }

      setAttendanceData(attendanceDataArray);

      // 5️⃣ Fetch TIMESHEET data
      let timesheetDataArray = [];

      console.log(`🎯 Fetching timesheets for: ${employeeName} (ID: ${employeeId}, Emp_ID: ${emp_id})`);

      // Try different endpoints for timesheets
      const timesheetEndpoints = [
        `${API_BASE_URL}/api/timesheets/emp_id/${emp_id}`,
        `${API_BASE_URL}/api/timesheets?emp_id=${emp_id}`,
        `${API_BASE_URL}/api/timesheets/employee/${employeeId}`,
        `${API_BASE_URL}/api/timesheets?employeeId=${employeeId}`,
        `${API_BASE_URL}/api/timesheets/employee/${emp_id}`,
      ];

      for (const endpoint of timesheetEndpoints) {
        if (timesheetDataArray.length > 0) break;
        
        try {
          console.log(`Trying timesheet endpoint: ${endpoint}`);
          const response = await fetch(endpoint, { headers });
          
          if (response.ok) {
            const data = await response.json();
            console.log(`📊 Timesheet response from ${endpoint}: ${data.length || 0} records`);
            
            if (Array.isArray(data)) {
              timesheetDataArray = data;
              console.log(`✅ Found ${timesheetDataArray.length} timesheets from ${endpoint}`);
              break;
            } else if (data.data && Array.isArray(data.data)) {
              timesheetDataArray = data.data;
              console.log(`✅ Found ${timesheetDataArray.length} timesheets from ${endpoint}`);
              break;
            } else if (data.success && Array.isArray(data.data)) {
              timesheetDataArray = data.data;
              console.log(`✅ Found ${timesheetDataArray.length} timesheets from ${endpoint}`);
              break;
            }
          } else {
            console.log(`❌ Timesheet endpoint failed: ${response.status}`);
          }
        } catch (err) {
          console.log(`Timesheet endpoint error:`, err.message);
        }
      }

      // Final filtering of timesheet data
      if (timesheetDataArray.length > 0) {
        const filteredTimesheets = timesheetDataArray.filter(sheet => {
          const sheetEmpId = sheet.emp_id || sheet.employeeId || 
                            (sheet.employee && sheet.employee.emp_id) ||
                            (sheet.employee && sheet.employee._id);
          
          const belongsToEmployee = sheetEmpId === emp_id || 
                                   sheetEmpId === employeeId ||
                                   (sheet.employeeId && sheet.employeeId.toString() === employeeId);
          
          if (!belongsToEmployee) {
            console.warn(`❌ Filtered out timesheet:`, {
              sheetEmpId: sheetEmpId,
              targetEmpId: emp_id,
              targetEmployeeId: employeeId
            });
          }
          
          return belongsToEmployee;
        });
        
        console.log(`🎯 FINAL: ${filteredTimesheets.length} timesheets after filtering`);
        
        if (filteredTimesheets.length !== timesheetDataArray.length) {
          console.warn(`⚠️ Filtered out ${timesheetDataArray.length - filteredTimesheets.length} invalid records`);
        }
        
        setTimesheetData(filteredTimesheets);
      } else {
        console.log(`📊 No timesheet records found`);
        setTimesheetData([]);
      }

      // 6️⃣ Fetch OTHER employee data in parallel - USING emp_id
      const [
        academicRes, 
        experienceRes, 
        documentRes,
        taskRes // ✅ ADDED TASK RES
      ] = await Promise.allSettled([
        // Academic info using emp_id
        fetch(`${API_BASE_URL}/api/academics/by-emp-id/${emp_id}`, { headers }),
        
        // Experience info using emp_id
        fetch(`${API_BASE_URL}/api/experience/by-emp-id/${emp_id}`, { headers }),
        
        // Documents using emp_id - NEW ENDPOINT
        fetch(`${API_BASE_URL}/api/documents/by-emp-id/${emp_id}`, { headers }),
        
        // ✅ TASKS using emp_id - IMPROVED FETCH
        fetch(`${API_BASE_URL}/api/tasks/emp_id/${emp_id}`, { headers })
      ]);

      // Process academic info
      if (academicRes.status === 'fulfilled' && academicRes.value.ok) {
        const academicResult = await academicRes.value.json();
        console.log("📚 Academic info response:", academicResult);
        
        if (academicResult.success && Array.isArray(academicResult.data)) {
          setAcademicData(academicResult.data);
          console.log(`✅ Found ${academicResult.data.length} academic records`);
        } else {
          console.log("❌ Academic data format error");
          setAcademicData([]);
        }
      } else {
        console.log("❌ Academic info fetch failed:", academicRes.reason);
        setAcademicData([]);
      }

      // Process experience info
      if (experienceRes.status === 'fulfilled' && experienceRes.value.ok) {
        const experienceResult = await experienceRes.value.json();
        console.log("💼 Experience info response:", experienceResult);
        
        if (experienceResult.success && Array.isArray(experienceResult.data)) {
          setExperienceData(experienceResult.data);
          console.log(`✅ Found ${experienceResult.data.length} experience records`);
        } else {
          console.log("❌ Experience data format error");
          setExperienceData([]);
        }
      } else {
        console.log("❌ Experience info fetch failed:", experienceRes.reason);
        setExperienceData([]);
      }

      // Process documents - ENHANCED
      if (documentRes.status === 'fulfilled' && documentRes.value.ok) {
        const documentResult = await documentRes.value.json();
        console.log("📄 Documents response:", documentResult);
        
        if (documentResult.success && Array.isArray(documentResult.data)) {
          // Process and format document data for better display
          const formattedDocuments = documentResult.data.map(doc => {
            // Create a proper document object
            return {
              _id: doc._id,
              name: doc.name || "Untitled Document",
              filename: doc.filename || doc.name || "document",
              contentType: doc.contentType,
              size: doc.size || 0,
              uploadedAt: doc.uploadedAt || doc.createdAt,
              uploadedVia: doc.uploadedVia || 'web',
              emp_id: doc.emp_id || emp_id,
              employeeId: doc.employeeId,
              // Create URLs for viewing/downloading
              viewUrl: doc.file || 
                      (doc._id ? `${API_BASE_URL}/api/documents/file/${doc._id}` : null),
              downloadUrl: doc._id ? 
                          `${API_BASE_URL}/api/documents/file/${doc._id}?download=true` : null
            };
          });
          
          setDocumentData(formattedDocuments);
          console.log(`✅ Found ${formattedDocuments.length} documents for emp_id: ${emp_id}`);
        } else {
          console.log("❌ Documents data format error");
          setDocumentData([]);
        }
      } else {
        console.log("❌ Documents fetch failed:", documentRes.reason);
        setDocumentData([]);
      }

      // ✅ IMPROVED: Process tasks response with better error handling
      console.log(`🎯 Fetching tasks for emp_id: ${emp_id}`);
      
      let tasksArray = [];
      let taskError = null;
      
      if (taskRes.status === 'fulfilled' && taskRes.value.ok) {
        try {
          const taskResult = await taskRes.value.json();
          console.log("📋 Task info raw response:", taskResult);
          
          // Handle different response formats
          if (taskResult.success) {
            if (Array.isArray(taskResult.data)) {
              tasksArray = taskResult.data;
              console.log(`✅ Found ${tasksArray.length} tasks from taskResult.data`);
            } else if (taskResult.data && typeof taskResult.data === 'object') {
              // If data is a single object, wrap it in array
              tasksArray = [taskResult.data];
              console.log(`✅ Found single task from taskResult.data`);
            }
          } else if (Array.isArray(taskResult)) {
            tasksArray = taskResult;
            console.log(`✅ Found ${tasksArray.length} tasks from direct array`);
          } else if (taskResult.tasks && Array.isArray(taskResult.tasks)) {
            tasksArray = taskResult.tasks;
            console.log(`✅ Found ${tasksArray.length} tasks from taskResult.tasks`);
          } else if (taskResult.data && Array.isArray(taskResult.data)) {
            tasksArray = taskResult.data;
            console.log(`✅ Found ${tasksArray.length} tasks from taskResult.data array`);
          }
          
          // If still no tasks, try alternative endpoints
          if (tasksArray.length === 0) {
            console.log(`🔄 No tasks found from primary endpoint, trying alternatives...`);
            
            // Try different task endpoints in sequence
            const alternativeTaskEndpoints = [
              `${API_BASE_URL}/api/tasks?emp_id=${emp_id}`,
              `${API_BASE_URL}/api/tasks/search?search=${emp_id}`,
              `${API_BASE_URL}/api/tasks/employee/${employeeId}`,
              `${API_BASE_URL}/api/tasks?employeeId=${employeeId}`,
              `${API_BASE_URL}/api/tasks?employeeId=${emp_id}`
            ];
            
            for (const endpoint of alternativeTaskEndpoints) {
              if (tasksArray.length > 0) break;
              
              try {
                console.log(`Trying alternative task endpoint: ${endpoint}`);
                const altResponse = await fetch(endpoint, { headers });
                
                if (altResponse.ok) {
                  const altData = await altResponse.json();
                  console.log(`Alternative response from ${endpoint}:`, altData);
                  
                  if (altData.success && Array.isArray(altData.data)) {
                    tasksArray = altData.data;
                  } else if (Array.isArray(altData)) {
                    tasksArray = altData;
                  } else if (altData.tasks && Array.isArray(altData.tasks)) {
                    tasksArray = altData.tasks;
                  } else if (altData.data && Array.isArray(altData.data)) {
                    tasksArray = altData.data;
                  }
                  
                  if (tasksArray.length > 0) {
                    console.log(`✅ Found ${tasksArray.length} tasks from ${endpoint}`);
                    break;
                  }
                }
              } catch (altErr) {
                console.log(`Alternative endpoint ${endpoint} error:`, altErr.message);
              }
            }
          }
        } catch (parseErr) {
          taskError = parseErr;
          console.log("❌ Error parsing task response:", parseErr);
        }
      } else {
        taskError = taskRes.reason || "Task fetch failed";
        console.log("❌ Tasks fetch failed:", taskRes.reason);
      }

      // Filter and process tasks
      if (tasksArray.length > 0) {
        // Filter tasks by emp_id or employeeId
        const filteredTasks = tasksArray.filter(task => {
          const taskEmpId = task.emp_id || 
                           (task.employeeId && typeof task.employeeId === 'object' ? task.employeeId.emp_id : null) ||
                           (task.employee && task.employee.emp_id);
          
          const taskEmployeeId = task.employeeId?._id || 
                                (typeof task.employeeId === 'string' ? task.employeeId : null) ||
                                task.employeeId;
          
          const belongsToEmployee = 
            taskEmpId === emp_id || 
            taskEmployeeId === employeeId ||
            (task.employeeId && task.employeeId.toString() === employeeId) ||
            (task.employee && task.employee._id === employeeId);
          
          if (!belongsToEmployee) {
            console.log(`⚠️ Filtered out task (not for this employee):`, {
              taskId: task._id,
              taskTitle: task.title,
              taskEmpId: taskEmpId,
              targetEmpId: emp_id,
              taskEmployeeId: taskEmployeeId,
              targetEmployeeId: employeeId
            });
          }
          
          return belongsToEmployee;
        });
        
        console.log(`🎯 FINAL: ${filteredTasks.length} tasks after filtering (from ${tasksArray.length} total)`);
        
        // Format task data for display
        const formattedTasks = filteredTasks.map(task => ({
          _id: task._id,
          title: task.title || 'Untitled Task',
          description: task.description,
          status: task.status || 'Not Started',
          priority: task.priority || 'Medium',
          dueDate: task.dueDate,
          managerId: task.managerId || (task.manager ? { 
            name: task.manager.name, 
            email: task.manager.email 
          } : null),
          emp_id: task.emp_id || emp_id,
          employeeId: task.employeeId,
          createdAt: task.createdAt,
          updatedAt: task.updatedAt,
          extraFields: task.extraFields || [],
          notes: task.notes || []
        }));
        
        setTaskData(formattedTasks);
      } else if (taskError) {
        console.log(`📋 No task records found for emp_id: ${emp_id}`, taskError);
        setTaskData([]);
      } else {
        console.log(`📋 No task records found for emp_id: ${emp_id}`);
        setTaskData([]);
      }

    } catch (error) {
      console.error("❌ Error fetching employee details:", error);
      // Reset all states on error
      setPersonalData(null);
      setLeaveData([]);
      setAttendanceData([]);
      setTimesheetData([]);
      setAcademicData([]);
      setExperienceData([]);
      setDocumentData([]);
      setTaskData([]); // ✅ RESET TASK DATA
      setCurrentEmpId("");
      setCurrentEmployeeName("");
    } finally {
      setLoadingDetails(false);
    }
  };

  const filteredEmployees = employees.filter(emp =>
    emp?.name?.toLowerCase().includes(search.toLowerCase()) ||
    emp?.department?.toLowerCase().includes(search.toLowerCase()) ||
    emp?.emp_id?.toLowerCase().includes(search.toLowerCase())
  );

  const renderTabContent = () => {
    switch (activeTab) {
      case "basic":
        return (
          <div className="basic-details-section">
            <div className="basic-section-header">
              <h4>
                <FiUser className="basic-header-icon" />
                Basic Information
              </h4>
              {selectedEmployee?.emp_id && (
                <div className="basic-header-badges">
                  <span className="basic-id-badge">
                    <FaIdCard className="basic-badge-icon" />
                    ID: {selectedEmployee.emp_id}
                  </span>
                  <span className={`basic-status-badge ${selectedEmployee?.status?.toLowerCase() || 'active'}`}>
                    <FiCheckCircle className="basic-badge-icon" />
                    {selectedEmployee?.status || "Active"}
                  </span>
                </div>
              )}
            </div>
            
            <div className="basic-info-grid">
              {/* Personal Information Card */}
              <div className="basic-info-card">
                <div className="basic-card-header">
                  <FiUser className="basic-card-icon" />
                  <h5>Personal Information</h5>
                </div>
                <div className="basic-card-content">
                  <div className="basic-info-row">
                    <div className="basic-info-label">
                      <FiUser className="basic-label-icon" />
                      <span>Full Name</span>
                    </div>
                    <div className="basic-info-value">
                      {selectedEmployee?.name || "N/A"}
                    </div>
                  </div>
                  
                  <div className="basic-info-row">
                    <div className="basic-info-label">
                      <FiMail className="basic-label-icon" />
                      <span>Email</span>
                    </div>
                    <div className="basic-info-value">
                      {selectedEmployee?.email || "N/A"}
                    </div>
                  </div>
                  
                  <div className="basic-info-row">
                    <div className="basic-info-label">
                      <FiPhone className="basic-label-icon" />
                      <span>Mobile</span>
                    </div>
                    <div className="basic-info-value">
                      {selectedEmployee?.mobile || "N/A"}
                    </div>
                  </div>
                  
                  {selectedEmployee?.dateOfBirth && (
                    <div className="basic-info-row">
                      <div className="basic-info-label">
                        <FiCalendar className="basic-label-icon" />
                        <span>Date of Birth</span>
                      </div>
                      <div className="basic-info-value">
                        {new Date(selectedEmployee.dateOfBirth).toLocaleDateString()}
                      </div>
                    </div>
                  )}
                  
                  {selectedEmployee?.gender && (
                    <div className="basic-info-row">
                      <div className="basic-info-label">
                        <FaTransgender className="basic-label-icon" />
                        <span>Gender</span>
                      </div>
                      <div className="basic-info-value">
                        {selectedEmployee.gender}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              
              {/* Professional Information Card */}
              <div className="basic-info-card">
                <div className="basic-card-header">
                  <FiBriefcase className="basic-card-icon" />
                  <h5>Professional Information</h5>
                </div>
                <div className="basic-card-content">
                  <div className="basic-info-row">
                    <div className="basic-info-label">
                      <FaIdCard className="basic-label-icon" />
                      <span>Employee ID</span>
                    </div>
                    <div className="basic-info-value basic-id-highlight">
                      {selectedEmployee?.emp_id || "N/A"}
                    </div>
                  </div>
                  
                  <div className="basic-info-row">
                    <div className="basic-info-label">
                      <FaBuilding className="basic-label-icon" />
                      <span>Department</span>
                    </div>
                    <div className="basic-info-value">
                      {selectedEmployee?.department || "N/A"}
                    </div>
                  </div>
                  
                  <div className="basic-info-row">
                    <div className="basic-info-label">
                      <FiBriefcase className="basic-label-icon" />
                      <span>Role/Position</span>
                    </div>
                    <div className="basic-info-value">
                      {selectedEmployee?.role || selectedEmployee?.designation || "N/A"}
                    </div>
                  </div>
                  
                  {selectedEmployee?.joiningDate && (
                    <div className="basic-info-row">
                      <div className="basic-info-label">
                        <FiCalendar className="basic-label-icon" />
                        <span>Joining Date</span>
                      </div>
                      <div className="basic-info-value">
                        {new Date(selectedEmployee.joiningDate).toLocaleDateString()}
                      </div>
                    </div>
                  )}
                  
                  {selectedEmployee?.reportingManager && (
                    <div className="basic-info-row">
                      <div className="basic-info-label">
                        <FiUserCheck className="basic-label-icon" />
                        <span>Reporting Manager</span>
                      </div>
                      <div className="basic-info-value">
                        {selectedEmployee.reportingManager}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              
              {/* Additional Information Card */}
              <div className="basic-info-card">
                <div className="basic-card-header">
                  <FiInfo className="basic-card-icon" />
                  <h5>Additional Information</h5>
                </div>
                <div className="basic-card-content">
                  <div className="basic-info-row">
                    <div className="basic-info-label">
                      <FiCheckCircle className="basic-label-icon" />
                      <span>Status</span>
                    </div>
                    <div className="basic-info-value">
                      <span className={`basic-status-indicator ${selectedEmployee?.status?.toLowerCase() || 'active'}`}>
                        {selectedEmployee?.status || "Active"}
                      </span>
                    </div>
                  </div>
                  
                  {selectedEmployee?.location && (
                    <div className="basic-info-row">
                      <div className="basic-info-label">
                        <FiMapPin className="basic-label-icon" />
                        <span>Location</span>
                      </div>
                      <div className="basic-info-value">
                        {selectedEmployee.location}
                      </div>
                    </div>
                  )}
                  
                  {selectedEmployee?.workLocation && (
                    <div className="basic-info-row">
                      <div className="basic-info-label">
                        <FaMapMarkerAlt className="basic-label-icon" />
                        <span>Work Location</span>
                      </div>
                      <div className="basic-info-value">
                        {selectedEmployee.workLocation}
                      </div>
                    </div>
                  )}
                  
                  {selectedEmployee?.employmentType && (
                    <div className="basic-info-row">
                      <div className="basic-info-label">
                        <FiBriefcase className="basic-label-icon" />
                        <span>Employment Type</span>
                      </div>
                      <div className="basic-info-value">
                        {selectedEmployee.employmentType}
                      </div>
                    </div>
                  )}
                  
                  {selectedEmployee?.employeeType && (
                    <div className="basic-info-row">
                      <div className="basic-info-label">
                        <FiUser className="basic-label-icon" />
                        <span>Employee Type</span>
                      </div>
                      <div className="basic-info-value">
                        {selectedEmployee.employeeType}
                      </div>
                    </div>
                  )}
                  
                  {selectedEmployee?.createdAt && (
                    <div className="basic-info-row">
                      <div className="basic-info-label">
                        <FiClock className="basic-label-icon" />
                        <span>Record Created</span>
                      </div>
                      <div className="basic-info-value">
                        {new Date(selectedEmployee.createdAt).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            
            {/* Employee ID Quick Info */}
            <div className="basic-quick-info">
              <div className="basic-quick-item">
                <FaIdCard className="basic-quick-icon" />
                <div className="basic-quick-content">
                  <span className="basic-quick-label">Employee ID</span>
                  <span className="basic-quick-value">{selectedEmployee?.emp_id || "N/A"}</span>
                </div>
              </div>
              
              <div className="basic-quick-item">
                <FiCheckCircle className="basic-quick-icon" />
                <div className="basic-quick-content">
                  <span className="basic-quick-label">Status</span>
                  <span className={`basic-quick-value ${selectedEmployee?.status?.toLowerCase() || 'active'}`}>
                    {selectedEmployee?.status || "Active"}
                  </span>
                </div>
              </div>
              
              <div className="basic-quick-item">
                <FaBuilding className="basic-quick-icon" />
                <div className="basic-quick-content">
                  <span className="basic-quick-label">Department</span>
                  <span className="basic-quick-value">{selectedEmployee?.department || "N/A"}</span>
                </div>
              </div>
              
              <div className="basic-quick-item">
                <FiBriefcase className="basic-quick-icon" />
                <div className="basic-quick-content">
                  <span className="basic-quick-label">Role</span>
                  <span className="basic-quick-value">{selectedEmployee?.role || "N/A"}</span>
                </div>
              </div>
            </div>
          </div>
        );

      case "leaves":
        return (
          <div className="leave-details-section">
            {/* Leave Details Modal */}
            {leaveShowModal && leaveSelectedLeave && (
              <div className="leave-modal-overlay" onClick={handleLeaveCloseModal}>
                <div className="leave-modal" onClick={(e) => e.stopPropagation()}>
                  <div className="leave-modal-header">
                    <h3 className="leave-modal-title">
                      <FiCalendar className="leave-modal-title-icon" />
                      Leave Application Details
                    </h3>
                    <button 
                      className="leave-modal-close-btn"
                      onClick={handleLeaveCloseModal}
                    >
                      <FiX />
                    </button>
                  </div>
                  
                  <div className="leave-modal-content">
                    <div className="leave-modal-summary">
                      <div className="leave-summary-card">
                        <div className="leave-summary-icon" style={{ color: getLeaveTypeColor(leaveSelectedLeave.leaveType) }}>
                          <FiCalendar />
                        </div>
                        <div className="leave-summary-info">
                          <h5>Leave Type</h5>
                          <p>{leaveSelectedLeave.leaveType || leaveSelectedLeave.type || 'General'}</p>
                        </div>
                      </div>
                      
                      <div className="leave-summary-card">
                        <div className="leave-summary-icon"><FiClock /></div>
                        <div className="leave-summary-info">
                          <h5>Duration</h5>
                          <p className="leave-duration">{leaveSelectedLeave.leaveDays || leaveSelectedLeave.totalDays || '0'} days</p>
                        </div>
                      </div>
                      
                      <div className="leave-summary-card">
                        <div className="leave-summary-icon" style={{ color: getStatusColors(leaveSelectedLeave.status) }}>
                          <FiBarChart />
                        </div>
                        <div className="leave-summary-info">
                          <h5>Status</h5>
                          <span 
                            className="leave-status-badge" 
                            style={{ 
                              backgroundColor: getStatusColor(leaveSelectedLeave.status) + '20', 
                              color: getStatusColor(leaveSelectedLeave.status) 
                            }}
                          >
                            {leaveSelectedLeave.status || 'Pending'}
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="leave-modal-details">
                      <div className="leave-detail-section">
                        <h5 className="leave-section-title">
                          <FiFileText className="leave-section-icon" />
                          Leave Information
                        </h5>
                        <div className="leave-detail-grid">
                          <div className="leave-detail-item">
                            <span className="leave-detail-label">Leave ID:</span>
                            <span className="leave-detail-value leave-id">
                              {leaveSelectedLeave._id?.substring(0, 8) || 'N/A'}
                            </span>
                          </div>
                          
                          <div className="leave-detail-item">
                            <span className="leave-detail-label">From Date:</span>
                            <span className="leave-detail-value">
                              {formatDate(leaveSelectedLeave.startDate)}
                            </span>
                          </div>
                          
                          <div className="leave-detail-item">
                            <span className="leave-detail-label">To Date:</span>
                            <span className="leave-detail-value">
                              {formatDate(leaveSelectedLeave.endDate)}
                            </span>
                          </div>
                          
                          <div className="leave-detail-item">
                            <span className="leave-detail-label">Total Days:</span>
                            <span className="leave-detail-value">
                              {leaveSelectedLeave.leaveDays || leaveSelectedLeave.totalDays || '0'}
                            </span>
                          </div>
                          
                          <div className="leave-detail-item">
                            <span className="leave-detail-label">Applied On:</span>
                            <span className="leave-detail-value">
                              {formatDateTime(leaveSelectedLeave.applicationDate || leaveSelectedLeave.createdAt)}
                            </span>
                          </div>
                          
                          {leaveSelectedLeave.approvedBy && (
                            <div className="leave-detail-item">
                              <span className="leave-detail-label">Approved By:</span>
                              <span className="leave-detail-value">
                                {leaveSelectedLeave.approvedBy}
                              </span>
                            </div>
                          )}
                          
                          {leaveSelectedLeave.approvedDate && (
                            <div className="leave-detail-item">
                              <span className="leave-detail-label">Approved On:</span>
                              <span className="leave-detail-value">
                                {formatDateTime(leaveSelectedLeave.approvedDate)}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                      
                      <div className="leave-detail-section">
                        <h5 className="leave-section-title">
                          <FiUser className="leave-section-icon" />
                          Employee Information
                        </h5>
                        <div className="leave-detail-grid">
                          <div className="leave-detail-item">
                            <span className="leave-detail-label">Employee Name:</span>
                            <span className="leave-detail-value">
                              {selectedEmployee?.name || leaveSelectedLeave.employeeName || 'N/A'}
                            </span>
                          </div>
                          
                          <div className="leave-detail-item">
                            <span className="leave-detail-label">Employee ID:</span>
                            <span className="leave-detail-value">
                              {selectedEmployee?.emp_id || leaveSelectedLeave.emp_id || 'N/A'}
                            </span>
                          </div>
                          
                          <div className="leave-detail-item">
                            <span className="leave-detail-label">Department:</span>
                            <span className="leave-detail-value">
                              {selectedEmployee?.department || leaveSelectedLeave.department || 'N/A'}
                            </span>
                          </div>
                          
                          <div className="leave-detail-item">
                            <span className="leave-detail-label">Designation:</span>
                            <span className="leave-detail-value">
                              {selectedEmployee?.designation || leaveSelectedLeave.designation || 'N/A'}
                            </span>
                          </div>
                        </div>
                      </div>
                      
                      {leaveSelectedLeave.reason && (
                        <div className="leave-detail-section">
                          <h5 className="leave-section-title">
                            <FiFileText className="leave-section-icon" />
                            Reason for Leave
                          </h5>
                          <div className="leave-reason-content">
                            {leaveSelectedLeave.reason}
                          </div>
                        </div>
                      )}
                      
                      {leaveSelectedLeave.comments && (
                        <div className="leave-detail-section">
                          <h5 className="leave-section-title">
                            <FiMessageSquare className="leave-section-icon" />
                            Comments/Notes
                          </h5>
                          <div className="leave-comments-content">
                            {leaveSelectedLeave.comments}
                          </div>
                        </div>
                      )}
                      
                      {leaveSelectedLeave.attachments && leaveSelectedLeave.attachments.length > 0 && (
                        <div className="leave-detail-section">
                          <h5 className="leave-section-title">
                            <FiPaperclip className="leave-section-icon" />
                            Attachments ({leaveSelectedLeave.attachments.length})
                          </h5>
                          <div className="leave-attachments-list">
                            {leaveSelectedLeave.attachments.map((attachment, index) => (
                              <div key={index} className="leave-attachment-item">
                                <FiPaperclip className="leave-attachment-icon" />
                                <span className="leave-attachment-name">{attachment.name || `Attachment ${index + 1}`}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  
                  <div className="leave-modal-footer">
                    <div className="leave-modal-actions">
                      <button 
                        className="leave-action-btn leave-close-btn"
                        onClick={handleLeaveCloseModal}
                      >
                        Close Details
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Main Leaves Section */}
            <div className="leave-section-header">
              <div className="leave-header-main">
                <h4>
                  <FiCalendar className="leave-header-icon" />
                  Leave Records ({leaveData.length || 0})
                  {upcomingLeaves.length > 0 && (
                    <span className="leave-upcoming-badge">
                      <FiAlertCircle className="leave-upcoming-icon" />
                      {upcomingLeaves.length} Upcoming
                    </span>
                  )}
                </h4>
                {selectedEmployee?.name && (
                  <div className="leave-employee-info">
                    <span className="leave-employee-name">
                      <FiUser className="leave-employee-icon" />
                      {selectedEmployee.name}
                    </span>
                    <span className="leave-employee-id">
                      <FaIdCard className="leave-id-icon" />
                      ID: {selectedEmployee.emp_id}
                    </span>
                  </div>
                )}
              </div>
              
              <div className="leave-header-actions">
                <button 
                  className="leave-refresh-btn"
                  onClick={() => selectedEmployee?._id && fetchEmployeeDetails(selectedEmployee._id)}
                >
                  <FiRefreshCw className="leave-refresh-icon" />
                  Refresh
                </button>
              </div>
            </div>
            
            {leaveData.length > 0 ? (
              <>
                {/* Statistics Cards */}
                <div className="leave-stats-container">
                  <div className="leave-stats-grid">
                    <div className="leave-stat-card">
                      <div className="leave-stat-icon">
                        <FiBarChart />
                      </div>
                      <div className="leave-stat-content">
                        <h5>Total Records</h5>
                        <p className="leave-stat-number">{leaveData.length}</p>
                      </div>
                    </div>
                    
                    <div className="leave-stat-card">
                      <div className="leave-stat-icon">
                        <FiCheckCircle />
                      </div>
                      <div className="leave-stat-content">
                        <h5>Approved</h5>
                        <p className="leave-stat-number">{approvedCount}</p>
                      </div>
                    </div>
                    
                    <div className="leave-stat-card">
                      <div className="leave-stat-icon">
                        <FiClock />
                      </div>
                      <div className="leave-stat-content">
                        <h5>Pending</h5>
                        <p className="leave-stat-number">{pendingCount}</p>
                      </div>
                    </div>
                    
                    <div className="leave-stat-card">
                      <div className="leave-stat-icon">
                        <FiCalendar />
                      </div>
                      <div className="leave-stat-content">
                        <h5>Total Days</h5>
                        <p className="leave-stat-number">{totalDays}</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Filter Controls */}
                <div className="leave-filter-container">
                  <div className="leave-filter-buttons">
                    <button 
                      className={`leave-filter-btn ${leaveFilter === 'all' ? 'active' : ''}`}
                      onClick={() => setLeaveFilter('all')}
                    >
                      All Leaves
                    </button>
                    <button 
                      className={`leave-filter-btn ${leaveFilter === 'approved' ? 'active' : ''}`}
                      onClick={() => setLeaveFilter('approved')}
                    >
                      Approved
                    </button>
                    <button 
                      className={`leave-filter-btn ${leaveFilter === 'pending' ? 'active' : ''}`}
                      onClick={() => setLeaveFilter('pending')}
                    >
                      Pending
                    </button>
                    <button 
                      className={`leave-filter-btn ${leaveFilter === 'rejected' ? 'active' : ''}`}
                      onClick={() => setLeaveFilter('rejected')}
                    >
                      Rejected
                    </button>
                  </div>
                  
                  <div className="leave-results-info">
                    Showing {filteredLeaves.length} of {leaveData.length} leave records
                  </div>
                </div>

                {/* Leaves Table */}
                <div className="leave-table-container">
                  <div className="leave-table-responsive">
                    <table className="leave-table">
                      <thead>
                        <tr>
                          <th>Leave ID</th>
                          <th>Type</th>
                          <th>From Date</th>
                          <th>To Date</th>
                          <th>Days</th>
                          <th>Status</th>
                          <th>Applied On</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredLeaves.map((leave, index) => {
                          const isUpcoming = leave.status === 'Approved' && new Date(leave.startDate) >= new Date();
                          
                          return (
                            <tr key={leave._id || index} className={`leave-table-row ${isUpcoming ? 'upcoming' : ''}`}>
                              <td>
                                <div className="leave-id-cell">
                                  <span className="leave-id-short">
                                    {leave._id?.substring(0, 8) || 'N/A'}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <span 
                                  className="leave-type-badge"
                                  style={{ 
                                    backgroundColor: getLeaveTypeColor(leave.leaveType) + '20', 
                                    color: getLeaveTypeColor(leave.leaveType) 
                                  }}
                                >
                                  {leave.leaveType || leave.type || 'General'}
                                </span>
                              </td>
                              <td>
                                <div className="leave-date-cell">
                                  <div className="leave-date-day">
                                    {new Date(leave.startDate).toLocaleDateString('en-US', { weekday: 'short' })}
                                  </div>
                                  <div className="leave-date-full">
                                    {formatDate(leave.startDate)}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="leave-date-cell">
                                  <div className="leave-date-day">
                                    {new Date(leave.endDate).toLocaleDateString('en-US', { weekday: 'short' })}
                                  </div>
                                  <div className="leave-date-full">
                                    {formatDate(leave.endDate)}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <span className="leave-days-badge">
                                  {leave.leaveDays || leave.totalDays || '0'} days
                                </span>
                              </td>
                              <td>
                                <span 
                                  className="leave-status-badge" 
                                  style={{ 
                                    backgroundColor: getStatusColor(leave.status) + '20', 
                                    color: getStatusColor(leave.status) 
                                  }}
                                >
                                  {leave.status || 'Pending'}
                                </span>
                              </td>
                              <td>
                                <div className="leave-applied-cell">
                                  {formatDate(leave.applicationDate || leave.createdAt)}
                                </div>
                              </td>
                              <td>
                                <div className="leave-action-cell">
                                  <button 
                                    className="leave-view-btn"
                                    onClick={() => handleLeaveViewClick(leave)}
                                  >
                                    <FiEye className="leave-view-icon" />
                                    View
                                  </button>
                                  
                                  {leave.reason && (
                                    <div className="leave-reason-preview">
                                      <FiFileText className="leave-reason-icon" />
                                      <span className="leave-reason-text" title={leave.reason}>
                                        {leave.reason.length > 20 ? `${leave.reason.substring(0, 20)}...` : leave.reason}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  
                  <div className="leave-table-footer">
                    <div className="leave-summary-info">
                      <strong>{selectedEmployee?.name}</strong> • Emp ID: <strong>{selectedEmployee?.emp_id}</strong>
                      {upcomingLeaves.length > 0 && (
                        <span className="leave-upcoming-info">
                          • <FiAlertTriangle /> {upcomingLeaves.length} upcoming leave(s)
                        </span>
                      )}
                    </div>
                    <div className="leave-pagination-info">
                      Total: {leaveData.length} records • {totalDays} days
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="leave-empty-state">
                <div className="leave-empty-icon"><FiCalendar /></div>
                <h5 className="leave-empty-title">No Leave Records Found</h5>
                <p className="leave-empty-text">
                  {selectedEmployee?.name 
                    ? `${selectedEmployee.name} hasn't applied for any leaves yet.`
                    : "No leave data available for this employee."
                  }
                </p>
              </div>
            )}
          </div>
        );

      case "attendance":
        return (
          <div className="attend-details-section">
            {/* Attendance Details Modal */}
            {attendShowModal && attendSelectedRecord && (
              <div className="attend-modal-overlay" onClick={handleAttendCloseModal}>
                <div className="attend-modal" onClick={(e) => e.stopPropagation()}>
                  <div className="attend-modal-header">
                    <h3 className="attend-modal-title">
                      <FaChartBar className="attend-modal-title-icon" />
                      Attendance Details
                    </h3>
                    <button 
                      className="attend-modal-close-btn"
                      onClick={handleAttendCloseModal}
                    >
                      <FiX />
                    </button>
                  </div>
                  
                  <div className="attend-modal-content">
                    <div className="attend-modal-summary">
                      <div className="attend-summary-card">
                        <div className="attend-summary-icon"><FiCalendar /></div>
                        <div className="attend-summary-info">
                          <h5>Date</h5>
                          <p>{formatDates(attendSelectedRecord.date || attendSelectedRecord.createdAt)}</p>
                        </div>
                      </div>
                      
                      <div className="attend-summary-card">
                        <div className="attend-summary-icon"><FiUser /></div>
                        <div className="attend-summary-info">
                          <h5>Employee</h5>
                          <p>{attendSelectedRecord.name || "N/A"}</p>
                        </div>
                      </div>
                      
                      <div className="attend-summary-card">
                        <div className="attend-summary-icon"><FiClock /></div>
                        <div className="attend-summary-info">
                          <h5>Duration</h5>
                          <p>{calculateDurations(
                            attendSelectedRecord.punchIn?.timestamp,
                            attendSelectedRecord.punchOut?.timestamp
                          )}</p>
                        </div>
                      </div>
                    </div>
                    
                    <div className="attend-modal-details">
                      {/* Punch In Details */}
                      <div className="attend-detail-section">
                        <h5 className="attend-section-title">
                          <FiArrowLeft className="attend-section-icon" />
                          Punch In Details
                        </h5>
                        <div className="attend-detail-grid">
                          <div className="attend-detail-item">
                            <span className="attend-detail-label">Time:</span>
                            <span className="attend-detail-value">
                              {formatTime(attendSelectedRecord.punchIn?.timestamp)}
                            </span>
                          </div>
                          
                          <div className="attend-detail-item">
                            <span className="attend-detail-label">Location:</span>
                            <span className="attend-detail-value">
                              {formatLocation(attendSelectedRecord.punchIn?.location)}
                            </span>
                          </div>
                          
                          <div className="attend-detail-item">
                            <span className="attend-detail-label">Method:</span>
                            <span className="attend-detail-value">
                              {attendSelectedRecord.punchIn?.method || "N/A"}
                            </span>
                          </div>
                        </div>
                        
                        {attendSelectedRecord.punchIn?.photo && (
                          <div className="attend-photo-preview">
                            <span className="attend-detail-label">Photo:</span>
                            <button 
                              className="attend-view-photo-btn"
                              onClick={() => {
                                const photoData = typeof attendSelectedRecord.punchIn.photo === 'string' 
                                  ? attendSelectedRecord.punchIn.photo 
                                  : `data:${attendSelectedRecord.punchIn.photo.contentType};base64,${attendSelectedRecord.punchIn.photo.data.toString("base64")}`;
                                handleAttendViewPhoto(photoData, `Punch In - ${attendSelectedRecord.date}`);
                                handleAttendCloseModal();
                              }}
                            >
                              <FiCamera className="attend-photo-icon" />
                              View Punch In Photo
                            </button>
                          </div>
                        )}
                      </div>
                      
                      {/* Punch Out Details */}
                      <div className="attend-detail-section">
                        <h5 className="attend-section-title">
                          <FiArrowLeft className="attend-section-icon" />
                          Punch Out Details
                        </h5>
                        <div className="attend-detail-grid">
                          <div className="attend-detail-item">
                            <span className="attend-detail-label">Time:</span>
                            <span className="attend-detail-value">
                              {formatTime(attendSelectedRecord.punchOut?.timestamp)}
                            </span>
                          </div>
                          
                          <div className="attend-detail-item">
                            <span className="attend-detail-label">Location:</span>
                            <span className="attend-detail-value">
                              {formatLocation(attendSelectedRecord.punchOut?.location)}
                            </span>
                          </div>
                          
                          <div className="attend-detail-item">
                            <span className="attend-detail-label">Method:</span>
                            <span className="attend-detail-value">
                              {attendSelectedRecord.punchOut?.method || "N/A"}
                            </span>
                          </div>
                        </div>
                        
                        {attendSelectedRecord.punchOut?.photo && (
                          <div className="attend-photo-preview">
                            <span className="attend-detail-label">Photo:</span>
                            <button 
                              className="attend-view-photo-btn"
                              onClick={() => {
                                const photoData = typeof attendSelectedRecord.punchOut.photo === 'string' 
                                  ? attendSelectedRecord.punchOut.photo 
                                  : `data:${attendSelectedRecord.punchOut.photo.contentType};base64,${attendSelectedRecord.punchOut.photo.data.toString("base64")}`;
                                handleAttendViewPhoto(photoData, `Punch Out - ${attendSelectedRecord.date}`);
                                handleAttendCloseModal();
                              }}
                            >
                              <FiCamera className="attend-photo-icon" />
                              View Punch Out Photo
                            </button>
                          </div>
                        )}
                      </div>
                      
                      {/* Additional Information */}
                      <div className="attend-detail-section">
                        <h5 className="attend-section-title">
                          <FiFileText className="attend-section-icon" />
                          Additional Information
                        </h5>
                        <div className="attend-detail-grid">
                          <div className="attend-detail-item">
                            <span className="attend-detail-label">Employee ID:</span>
                            <span className="attend-detail-value">
                              {attendSelectedRecord.emp_id || "N/A"}
                            </span>
                          </div>
                          
                          <div className="attend-detail-item">
                            <span className="attend-detail-label">Status:</span>
                            <span className={`attend-status-badge ${getAttendanceStatus(attendSelectedRecord).toLowerCase()}`}>
                              {getAttendanceStatus(attendSelectedRecord)}
                            </span>
                          </div>
                          
                          <div className="attend-detail-item">
                            <span className="attend-detail-label">Record ID:</span>
                            <span className="attend-detail-value attend-record-id">
                              {attendSelectedRecord._id?.substring(0, 8) || "N/A"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="attend-modal-footer">
                    <div className="attend-modal-actions">
                      <button 
                        className="attend-action-btn attend-close-btn"
                        onClick={handleAttendCloseModal}
                      >
                        Close Details
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Photo Modal */}
            {attendShowPhotoModal && (
              <div className="attend-photo-modal-overlay" onClick={handleAttendClosePhotoModal}>
                <div className="attend-photo-modal" onClick={(e) => e.stopPropagation()}>
                  <div className="attend-photo-modal-header">
                    <h3 className="attend-photo-modal-title">
                      <FiCamera className="attend-photo-modal-icon" />
                      {attendPhotoTitle}
                    </h3>
                    <button 
                      className="attend-photo-modal-close-btn"
                      onClick={handleAttendClosePhotoModal}
                    >
                      <FiX />
                    </button>
                  </div>
                  
                  <div className="attend-photo-modal-content">
                    {attendSelectedPhoto ? (
                      <img 
                        src={attendSelectedPhoto} 
                        alt="Attendance Photo" 
                        className="attend-photo-image"
                      />
                    ) : (
                      <div className="attend-no-photo">
                        <div className="attend-no-photo-icon"><FiCamera /></div>
                        <p>No photo available</p>
                      </div>
                    )}
                  </div>
                  
                  <div className="attend-photo-modal-footer">
                    <button 
                      className="attend-action-btn attend-close-btn"
                      onClick={handleAttendClosePhotoModal}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Main Attendance Section */}
            <div className="attend-section-header">
              <div className="attend-header-main">
                <h4>
                  <FaChartBar className="attend-header-icon" />
                  Attendance Records ({attendanceData.length || 0})
                </h4>
                {selectedEmployee?.name && (
                  <div className="attend-employee-info">
                    <span className="attend-employee-name"><FiUser /> {selectedEmployee.name}</span>
                    <span className="attend-employee-id"><FaIdCard /> {selectedEmployee.emp_id}</span>
                  </div>
                )}
              </div>
              
              <div className="attend-header-actions">
                <button 
                  className="attend-refresh-btn"
                  onClick={() => selectedEmployee?._id && fetchEmployeeDetails(selectedEmployee._id)}
                >
                  <FiRefreshCw className="attend-refresh-icon" />
                  Refresh
                </button>
              </div>
            </div>
            
            {loadingDetails ? (
              <div className="attend-loading">
                <div className="attend-loading-spinner"></div>
                <p>Loading attendance data...</p>
              </div>
            ) : attendanceData.length > 0 ? (
              <>
                {/* Statistics Cards */}
                <div className="attend-stats-container">
                  <div className="attend-stats-grid">
                    <div className="attend-stat-card">
                      <div className="attend-stat-icon">
                        <FiBarChart />
                      </div>
                      <div className="attend-stat-content">
                        <h5>Total Records</h5>
                        <p className="attend-stat-number">{attendanceData.length}</p>
                      </div>
                    </div>
                    
                    <div className="attend-stat-card">
                      <div className="attend-stat-icon">
                        <FiCheckCircle />
                      </div>
                      <div className="attend-stat-content">
                        <h5>Present</h5>
                        <p className="attend-stat-number">{presentCount}</p>
                      </div>
                    </div>
                    
                    <div className="attend-stat-card">
                      <div className="attend-stat-icon">
                        <FiClock />
                      </div>
                      <div className="attend-stat-content">
                        <h5>Pending</h5>
                        <p className="attend-stat-number">{pendingCount}</p>
                      </div>
                    </div>
                    
                    <div className="attend-stat-card">
                      <div className="attend-stat-icon">
                        <FiXCircle />
                      </div>
                      <div className="attend-stat-content">
                        <h5>Absent</h5>
                        <p className="attend-stat-number">{absentCount}</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Filter Controls */}
                <div className="attend-filter-container">
                  <div className="attend-filter-buttons">
                    <button 
                      className={`attend-filter-btn ${attendFilter === 'all' ? 'active' : ''}`}
                      onClick={() => setAttendFilter('all')}
                    >
                      All Records
                    </button>
                    <button 
                      className={`attend-filter-btn ${attendFilter === 'present' ? 'active' : ''}`}
                      onClick={() => setAttendFilter('present')}
                    >
                      Present
                    </button>
                    <button 
                      className={`attend-filter-btn ${attendFilter === 'pending' ? 'active' : ''}`}
                      onClick={() => setAttendFilter('pending')}
                    >
                      Pending
                    </button>
                    <button 
                      className={`attend-filter-btn ${attendFilter === 'absent' ? 'active' : ''}`}
                      onClick={() => setAttendFilter('absent')}
                    >
                      Absent
                    </button>
                  </div>
                  
                  <div className="attend-results-info">
                    Showing {filteredAttendance.slice(0, 20).length} of {attendanceData.length} records
                  </div>
                </div>

                {/* Attendance Table */}
                <div className="attend-table-container">
                  <div className="attend-table-responsive">
                    <table className="attend-table">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Employee ID</th>
                          <th>Name</th>
                          <th>Status</th>
                          <th>Punch In</th>
                          <th>Punch Out</th>
                          <th>Location</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredAttendance.slice(0, 20).map((record, index) => {
                          const status = getAttendanceStatus(record);
                          const hasPunchInPhoto = record.punchIn?.photo && 
                            (typeof record.punchIn.photo === 'string' || record.punchIn.photo.data);
                          const hasPunchOutPhoto = record.punchOut?.photo && 
                            (typeof record.punchOut.photo === 'string' || record.punchOut.photo.data);

                          return (
                            <tr key={index} className="attend-table-row">
                              <td>
                                <div className="attend-date-cell">
                                  <div className="attend-date-day">
                                    {new Date(record.date || record.createdAt).toLocaleDateString('en-US', { weekday: 'short' })}
                                  </div>
                                  <div className="attend-date-full">
                                    {new Date(record.date || record.createdAt).toLocaleDateString()}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <span className="attend-emp-id">{record.emp_id || "N/A"}</span>
                              </td>
                              <td>
                                <div className="attend-name-cell">
                                  {record.name || "N/A"}
                                  {record.name !== selectedEmployee?.name && (
                                    <span className="attend-name-warning"><FiAlertTriangle /></span>
                                  )}
                                </div>
                              </td>
                              <td>
                                <span className={`attend-status-badge ${status.toLowerCase()}`}>
                                  {status}
                                </span>
                              </td>
                              <td>
                                <div className="attend-time-cell">
                                  {record.punchIn?.timestamp ? 
                                    formatTime(record.punchIn.timestamp) : 
                                    <span className="attend-time-na">N/A</span>}
                                </div>
                              </td>
                              <td>
                                <div className="attend-time-cell">
                                  {record.punchOut?.timestamp ? 
                                    formatTime(record.punchOut.timestamp) : 
                                    <span className="attend-time-na">N/A</span>}
                                </div>
                              </td>
                              <td>
                                <div className="attend-location-cell">
                                  <div className="attend-location-in">
                                    <FiArrowLeft className="attend-location-icon" />
                                    {formatLocation(record.punchIn?.location)}
                                  </div>
                                  <div className="attend-location-out">
                                    <FiArrowLeft className="attend-location-icon" />
                                    {formatLocation(record.punchOut?.location)}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="attend-action-cell">
                                  <button 
                                    className="attend-view-btn"
                                    onClick={() => handleAttendViewClick(record)}
                                  >
                                    <FiEye className="attend-view-icon" />
                                    View
                                  </button>
                                  
                                  <div className="attend-photo-actions">
                                    {hasPunchInPhoto && (
                                      <button 
                                        className="attend-photo-btn"
                                        onClick={() => {
                                          const photoData = typeof record.punchIn.photo === 'string' 
                                            ? record.punchIn.photo 
                                            : `data:${record.punchIn.photo.contentType};base64,${record.punchIn.photo.data.toString("base64")}`;
                                          handleAttendViewPhoto(photoData, `Punch In - ${record.date}`);
                                        }}
                                      >
                                        <FiCamera /> In
                                      </button>
                                    )}
                                    
                                    {hasPunchOutPhoto && (
                                      <button 
                                        className="attend-photo-btn"
                                        onClick={() => {
                                          const photoData = typeof record.punchOut.photo === 'string' 
                                            ? record.punchOut.photo 
                                            : `data:${record.punchOut.photo.contentType};base64,${record.punchOut.photo.data.toString("base64")}`;
                                          handleAttendViewPhoto(photoData, `Punch Out - ${record.date}`);
                                        }}
                                      >
                                        <FiCamera /> Out
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  
                  {attendanceData.length > 20 && (
                    <div className="attend-table-footer">
                      <div className="attend-pagination-info">
                        Showing 20 of {attendanceData.length} records • Page 1
                      </div>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <div className="attend-empty-state">
                <div className="attend-empty-icon"><FiCalendar /></div>
                <h5 className="attend-empty-title">No Attendance Records Found</h5>
                <p className="attend-empty-text">
                  {selectedEmployee?.name 
                    ? `${selectedEmployee.name} hasn't marked any attendance yet.`
                    : "No attendance data available for this employee."
                  }
                </p>
              </div>
            )}
          </div>
        );

      case "timesheet":
        return (
          <div className="timsh-details-section">
            {/* Timesheet Details Modal */}
            {timshShowModal && timshSelectedSheet && (
              <div className="timsh-modal-overlay" onClick={handleTimshCloseModal}>
                <div className="timsh-modal" onClick={(e) => e.stopPropagation()}>
                  <div className="timsh-modal-header">
                    <h3 className="timsh-modal-title">
                      <FiFileText className="timsh-modal-title-icon" />
                      Timesheet Details
                    </h3>
                    <button 
                      className="timsh-modal-close-btn"
                      onClick={handleTimshCloseModal}
                    >
                      <FiX />
                    </button>
                  </div>
                  
                  <div className="timsh-modal-content">
                    <div className="timsh-modal-summary">
                      <div className="timsh-summary-card">
                        <div className="timsh-summary-icon"><FiCalendar /></div>
                        <div className="timsh-summary-info">
                          <h5>Date</h5>
                          <p>{formatDate(timshSelectedSheet.date || timshSelectedSheet.createdAt)}</p>
                        </div>
                      </div>
                      
                      <div className="timsh-summary-card">
                        <div className="timsh-summary-icon"><FiClock /></div>
                        <div className="timsh-summary-info">
                          <h5>Hours</h5>
                          <p className="timsh-hours">{timshSelectedSheet.hours || "0"}h</p>
                        </div>
                      </div>
                      
                      <div className="timsh-summary-card">
                        <div className="timsh-summary-icon" style={{ color: getStatusColor(timshSelectedSheet.status) }}><FiBarChart /></div>
                        <div className="timsh-summary-info">
                          <h5>Status</h5>
                          <span className="timsh-status-badge" style={{ backgroundColor: getStatusColor(timshSelectedSheet.status) + '20', color: getStatusColor(timshSelectedSheet.status) }}>
                            {timshSelectedSheet.status || 'Submitted'}
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="timsh-modal-details">
                      <div className="timsh-detail-section">
                        <h5 className="timsh-section-title">
                          <FiFileText className="timsh-section-icon" />
                          Task Information
                        </h5>
                        <div className="timsh-detail-grid">
                          <div className="timsh-detail-item">
                            <span className="timsh-detail-label">Task Title:</span>
                            <span className="timsh-detail-value">{timshSelectedSheet.task || "N/A"}</span>
                          </div>
                          
                          <div className="timsh-detail-item">
                            <span className="timsh-detail-label">Project:</span>
                            <span className="timsh-detail-value">{timshSelectedSheet.project || "N/A"}</span>
                          </div>
                          
                          {timshSelectedSheet.description && (
                            <div className="timsh-detail-item full-width">
                              <span className="timsh-detail-label">Description:</span>
                              <span className="timsh-detail-value">{timshSelectedSheet.description}</span>
                            </div>
                          )}
                        </div>
                      </div>
                      
                      <div className="timsh-detail-section">
                        <h5 className="timsh-section-title">
                          <FiUser className="timsh-section-icon" />
                          Employee Information
                        </h5>
                        <div className="timsh-detail-grid">
                          <div className="timsh-detail-item">
                            <span className="timsh-detail-label">Employee Name:</span>
                            <span className="timsh-detail-value">
                              {timshSelectedSheet.employeeName || selectedEmployee?.name || "N/A"}
                            </span>
                          </div>
                          
                          <div className="timsh-detail-item">
                            <span className="timsh-detail-label">Employee ID:</span>
                            <span className="timsh-detail-value">{selectedEmployee?.emp_id || "N/A"}</span>
                          </div>
                          
                          <div className="timsh-detail-item">
                            <span className="timsh-detail-label">Submitted On:</span>
                            <span className="timsh-detail-value">
                              {formatDate(timshSelectedSheet.createdAt)}
                            </span>
                          </div>
                          
                          {timshSelectedSheet.approvedBy && (
                            <div className="timsh-detail-item">
                              <span className="timsh-detail-label">Approved By:</span>
                              <span className="timsh-detail-value">{timshSelectedSheet.approvedBy}</span>
                            </div>
                          )}
                          
                          {timshSelectedSheet.approvedAt && (
                            <div className="timsh-detail-item">
                              <span className="timsh-detail-label">Approved On:</span>
                              <span className="timsh-detail-value">{formatDate(timshSelectedSheet.approvedAt)}</span>
                            </div>
                          )}
                        </div>
                      </div>
                      
                      {timshSelectedSheet.extraFields && timshSelectedSheet.extraFields.length > 0 && (
                        <div className="timsh-detail-section">
                          <h5 className="timsh-section-title">
                            <FiBarChart className="timsh-section-icon" />
                            Additional Details ({timshSelectedSheet.extraFields.length})
                          </h5>
                          <div className="timsh-extra-fields">
                            {timshSelectedSheet.extraFields.map((field, index) => (
                              <div key={index} className="timsh-extra-field">
                                <span className="timsh-field-label">{field.label || `Field ${index + 1}`}:</span>
                                <span className="timsh-field-value">{field.value || field.originalname || "N/A"}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      
                      {timshSelectedSheet.notes && (
                        <div className="timsh-detail-section">
                          <h5 className="timsh-section-title">
                            <FiMessageSquare className="timsh-section-icon" />
                            Notes
                          </h5>
                          <div className="timsh-notes-content">
                            {timshSelectedSheet.notes}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  
                  <div className="timsh-modal-footer">
                    <div className="timsh-modal-actions">
                      {timshSelectedSheet.downloadUrl && (
                        <button 
                          className="timsh-action-btn timsh-download-btn"
                          onClick={() => {
                            const link = document.createElement('a');
                            link.href = timshSelectedSheet.downloadUrl;
                            link.download = `timesheet_${selectedEmployee?.emp_id}_${timshSelectedSheet.date || timshSelectedSheet.createdAt}.pdf`;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                          }}
                        >
                          <FiDownload className="timsh-btn-icon" />
                          Download PDF
                        </button>
                      )}
                      
                      <button 
                        className="timsh-action-btn timsh-close-btn"
                        onClick={handleTimshCloseModal}
                      >
                        Close Details
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Main Timesheet Section */}
            <div className="timsh-section-header">
              <div className="timsh-header-main">
                <h4>
                  <FiFileText className="timsh-header-icon" />
                  Timesheet Records
                  {selectedEmployee?.name && ` for ${selectedEmployee.name}`}
                </h4>
                <div className="timsh-employee-info">
                  <span className="timsh-employee-id"><FaIdCard /> ID: {selectedEmployee?.emp_id || "N/A"}</span>
                  <span className="timsh-mongo-id"><FiDatabase /> MongoDB: {selectedEmployee?._id?.substring(0, 8)}...</span>
                </div>
              </div>
              
              <div className="timsh-header-actions">
                <button 
                  className="timsh-refresh-btn"
                  onClick={() => selectedEmployee?._id && fetchEmployeeDetails(selectedEmployee._id)}
                >
                  <FiRefreshCw className="timsh-refresh-icon" />
                  Refresh Data
                </button>
              </div>
            </div>
            
            {loadingDetails ? (
              <div className="timsh-loading">
                <div className="timsh-loading-spinner"></div>
                <p>Loading timesheet data...</p>
              </div>
            ) : timesheetData.length > 0 ? (
              <>
                {/* Statistics Cards */}
                <div className="timsh-stats-container">
                  <div className="timsh-stats-grid">
                    <div className="timsh-stat-card">
                      <div className="timsh-stat-icon">
                        <FiBarChart />
                      </div>
                      <div className="timsh-stat-content">
                        <h5>Total Records</h5>
                        <p className="timsh-stat-number">{timesheetData.length}</p>
                      </div>
                    </div>
                    
                    <div className="timsh-stat-card">
                      <div className="timsh-stat-icon">
                        <FiClock />
                      </div>
                      <div className="timsh-stat-content">
                        <h5>Total Hours</h5>
                        <p className="timsh-stat-number">{totalHours}h</p>
                      </div>
                    </div>
                    
                    <div className="timsh-stat-card">
                      <div className="timsh-stat-icon">
                        <FiCheckCircle />
                      </div>
                      <div className="timsh-stat-content">
                        <h5>Completed</h5>
                        <p className="timsh-stat-number">{completedCount}</p>
                      </div>
                    </div>
                    
                    <div className="timsh-stat-card">
                      <div className="timsh-stat-icon">
                        <FiClock />
                      </div>
                      <div className="timsh-stat-content">
                        <h5>Pending</h5>
                        <p className="timsh-stat-number">{pendingCount}</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Filter Controls */}
                <div className="timsh-filter-container">
                  <div className="timsh-filter-buttons">
                    <button 
                      className={`timsh-filter-btn ${timshFilter === 'all' ? 'active' : ''}`}
                      onClick={() => setTimshFilter('all')}
                    >
                      All Records
                    </button>
                    <button 
                      className={`timsh-filter-btn ${timshFilter === 'completed' ? 'active' : ''}`}
                      onClick={() => setTimshFilter('completed')}
                    >
                      Completed
                    </button>
                    <button 
                      className={`timsh-filter-btn ${timshFilter === 'pending' ? 'active' : ''}`}
                      onClick={() => setTimshFilter('pending')}
                    >
                      Pending
                    </button>
                    <button 
                      className={`timsh-filter-btn ${timshFilter === 'rejected' ? 'active' : ''}`}
                      onClick={() => setTimshFilter('rejected')}
                    >
                      Rejected
                    </button>
                  </div>
                  
                  <div className="timsh-results-info">
                    Showing {filteredTimesheets.length} of {timesheetData.length} records
                  </div>
                </div>

                {/* Timesheet Table */}
                <div className="timsh-table-container">
                  <div className="timsh-table-responsive">
                    <table className="timsh-table">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Task</th>
                          <th>Hours</th>
                          <th>Status</th>
                          <th>Submitted</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredTimesheets.map((sheet, index) => (
                          <tr key={index} className="timsh-table-row">
                            <td>
                              <div className="timsh-date-cell">
                                <div className="timsh-date-day">
                                  {new Date(sheet.date || sheet.createdAt).toLocaleDateString('en-US', { weekday: 'short' })}
                                </div>
                                <div className="timsh-date-full">
                                  {new Date(sheet.date || sheet.createdAt).toLocaleDateString()}
                                </div>
                              </div>
                            </td>
                            <td className="timsh-task-cell">
                              <div className="timsh-task-title">{sheet.task || "N/A"}</div>
                              {sheet.project && (
                                <div className="timsh-project-name">
                                  <FiFolder /> {sheet.project}
                                </div>
                              )}
                              {sheet.employeeName && sheet.employeeName !== selectedEmployee?.name && (
                                <div className="timsh-name-warning">
                                  <FiAlertTriangle /> Name mismatch: {sheet.employeeName}
                                </div>
                              )}
                            </td>
                            <td>
                              <span className="timsh-hours-badge">
                                {sheet.hours || "0"}h
                              </span>
                            </td>
                            <td>
                              <span 
                                className="timsh-status-badge" 
                                style={{ 
                                  backgroundColor: getStatusColor(sheet.status) + '20', 
                                  color: getStatusColor(sheet.status) 
                                }}
                              >
                                {sheet.status || 'Submitted'}
                              </span>
                            </td>
                            <td>
                              <div className="timsh-submitted-date">
                                {new Date(sheet.createdAt).toLocaleDateString()}
                              </div>
                            </td>
                            <td>
                              <div className="timsh-action-cell">
                                <button 
                                  className="timsh-view-btn"
                                  onClick={() => handleTimshViewClick(sheet)}
                                >
                                  <FiEye className="timsh-view-icon" />
                                  View
                                </button>
                                
                                {sheet.extraFields && sheet.extraFields.length > 0 && (
                                  <span className="timsh-extra-count">
                                    +{sheet.extraFields.length}
                                  </span>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  
                  <div className="timsh-table-footer">
                    <div className="timsh-summary-info">
                      <strong>{selectedEmployee?.name}</strong> • Emp ID: <strong>{selectedEmployee?.emp_id}</strong>
                    </div>
                    <div className="timsh-pagination-info">
                      Page 1 of 1 • Total: {timesheetData.length} records
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="timsh-empty-state">
                <div className="timsh-empty-icon"><FiFileText /></div>
                <h5 className="timsh-empty-title">No Timesheet Records Found</h5>
                <p className="timsh-empty-text">
                  {selectedEmployee?.name 
                    ? `${selectedEmployee.name} hasn't submitted any timesheets yet.`
                    : "No employee selected or timesheet data available."
                  }
                </p>
                
                <div className="timsh-debug-info">
                  <h6 className="timsh-debug-title">Debug Information:</h6>
                  <div className="timsh-debug-grid">
                    <div className="timsh-debug-item">
                      <span className="timsh-debug-label">Employee ID:</span>
                      <span className="timsh-debug-value">{selectedEmployee?._id || "N/A"}</span>
                    </div>
                    <div className="timsh-debug-item">
                      <span className="timsh-debug-label">Emp ID:</span>
                      <span className="timsh-debug-value">{selectedEmployee?.emp_id || "N/A"}</span>
                    </div>
                    <div className="timsh-debug-item">
                      <span className="timsh-debug-label">Name:</span>
                      <span className="timsh-debug-value">{selectedEmployee?.name || "N/A"}</span>
                    </div>
                    <div className="timsh-debug-item">
                      <span className="timsh-debug-label">Data Count:</span>
                      <span className="timsh-debug-value">{timesheetData.length} records</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        );

      case "tasks":
        return (
          <div className="taske-details-section">
            {/* Popup Modal */}
            {taskeShowModal && taskeSelectedTask && (
              <div className="taske-modal-overlay" onClick={handleTaskeCloseModal}>
                <div className="taske-modal" onClick={(e) => e.stopPropagation()}>
                  <div className="taske-modal-header">
                    <h3 className="taske-modal-title">
                      <FiFileText className="taske-modal-title-icon" />
                      Task Details
                    </h3>
                    <button 
                      className="taske-modal-close-btn"
                      onClick={handleTaskeCloseModal}
                    >
                      <FiX />
                    </button>
                  </div>
                  
                  <div className="taske-modal-content">
                    <div className="taske-modal-section">
                      <div className="taske-modal-row">
                        <span className="taske-modal-label">Title:</span>
                        <span className="taske-modal-value">{taskeSelectedTask.title}</span>
                      </div>
                      
                      <div className="taske-modal-row">
                        <span className="taske-modal-label">Status:</span>
                        <span className={`taske-modal-status ${taskeSelectedTask.status?.toLowerCase().replace(' ', '-')}`}>
                          {taskeSelectedTask.status || 'Not Started'}
                        </span>
                      </div>
                      
                      <div className="taske-modal-row">
                        <span className="taske-modal-label">Description:</span>
                        <span className="taske-modal-value">
                          {taskeSelectedTask.description || 'No description'}
                        </span>
                      </div>
                      
                      <div className="taske-modal-row">
                        <span className="taske-modal-label">Due Date:</span>
                        <span className="taske-modal-value">
                          {taskeSelectedTask.dueDate ? new Date(taskeSelectedTask.dueDate).toLocaleDateString() : 'No due date'}
                        </span>
                      </div>
                      
                      <div className="taske-modal-row">
                        <span className="taske-modal-label">Assigned By:</span>
                        <span className="taske-modal-value">
                          {taskeSelectedTask.managerId?.name || 'N/A'}
                        </span>
                      </div>
                      
                      <div className="taske-modal-row">
                        <span className="taske-modal-label">Created:</span>
                        <span className="taske-modal-value">
                          {taskeSelectedTask.createdAt ? new Date(taskeSelectedTask.createdAt).toLocaleDateString() : 'N/A'}
                        </span>
                      </div>
                      
                      <div className="taske-modal-row">
                        <span className="taske-modal-label">Updated:</span>
                        <span className="taske-modal-value">
                          {taskeSelectedTask.updatedAt ? new Date(taskeSelectedTask.updatedAt).toLocaleDateString() : 'N/A'}
                        </span>
                      </div>
                      
                      <div className="taske-modal-row">
                        <span className="taske-modal-label">Employee:</span>
                        <span className="taske-modal-value">
                          {selectedEmployee?.name || 'N/A'}
                        </span>
                      </div>
                      
                      <div className="taske-modal-row">
                        <span className="taske-modal-label">Employee ID:</span>
                        <span className="taske-modal-value">
                          {currentEmpId || selectedEmployee?.emp_id || 'N/A'}
                        </span>
                      </div>
                      
                      <div className="taske-modal-row">
                        <span className="taske-modal-label">Notes:</span>
                        <span className="taske-modal-value">
                          {taskeSelectedTask.notes && taskeSelectedTask.notes.length > 0 ? `${taskeSelectedTask.notes.length} notes` : 'No notes'}
                        </span>
                      </div>
                      
                      <div className="taske-modal-row">
                        <span className="taske-modal-label">Extra Fields:</span>
                        <span className="taske-modal-value">
                          {taskeSelectedTask.extraFields && taskeSelectedTask.extraFields.length > 0 ? `${taskeSelectedTask.extraFields.length} fields` : 'No extra fields'}
                        </span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="taske-modal-footer">
                    <button 
                      className="taske-modal-close-btn-main"
                      onClick={handleTaskeCloseModal}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}

            <div className="taske-section-header">
              <h4><FiFileText /> Task Assignments ({taskData.length})</h4>
              <button 
                className="taske-refresh-btn-sm"
                onClick={() => selectedEmployee?._id && fetchEmployeeDetails(selectedEmployee._id)}
              >
                <FiRefreshCw /> Refresh
              </button>
            </div>
            
            {loadingDetails ? (
              <div className="taske-loading">Loading tasks...</div>
            ) : taskData.length > 0 ? (
              <>
                <div className="taske-stats-summary">
                  <div className="taske-stat-item">
                    <span className="taske-stat-number">
                      {taskData.filter(task => task.status === 'Completed').length}
                    </span>
                    <span className="taske-stat-label">Completed</span>
                  </div>
                  <div className="taske-stat-item">
                    <span className="taske-stat-number">
                      {taskData.filter(task => task.status === 'In Progress').length}
                    </span>
                    <span className="taske-stat-label">In Progress</span>
                  </div>
                  <div className="taske-stat-item">
                    <span className="taske-stat-number">
                      {taskData.filter(task => task.status === 'Not Started').length}
                    </span>
                    <span className="taske-stat-label">Not Started</span>
                  </div>
                  <div className="taske-stat-item">
                    <span className="taske-stat-number">{taskData.length}</span>
                    <span className="taske-stat-label">Total Tasks</span>
                  </div>
                </div>
                
                <div className="taske-data-table">
                  <table>
                    <thead>
                      <tr>
                        <th>Task Title</th>
                        <th>Status</th>
                        <th>Due Date</th>
                        <th>Assigned By</th>
                        <th>Created On</th>
                        <th>View</th>
                      </tr>
                    </thead>
                    <tbody>
                      {taskData.map((task, index) => (
                        <tr key={task._id || index}>
                          <td>
                            <div className="taske-title-cell">
                              <strong>{task.title}</strong>
                              {task.description && (
                                <small className="taske-description-small">
                                  {task.description.length > 50 
                                    ? `${task.description.substring(0, 50)}...` 
                                    : task.description}
                                </small>
                              )}
                            </div>
                          </td>
                          <td>
                            <span className={`taske-status-badge ${task.status?.toLowerCase().replace(' ', '-')}`}>
                              {task.status || 'Not Started'}
                            </span>
                          </td>
                          <td>
                            {task.dueDate ? new Date(task.dueDate).toLocaleDateString() : 'No due date'}
                          </td>
                          <td>
                            {task.managerId?.name || 'N/A'}
                          </td>
                          <td>
                            {task.createdAt ? new Date(task.createdAt).toLocaleDateString() : 'N/A'}
                          </td>
                          <td>
                            <button 
                              className="taske-btn-small"
                              onClick={() => handleTaskeViewClick(task)}
                            >
                              <FiEye /> View
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                
                <div className="taske-data-footer">
                  Showing {taskData.length} task records
                  {selectedEmployee?.name && ` for ${selectedEmployee.name}`}
                </div>
              </>
            ) : (
              <div className="taske-no-data-message">
                <div className="taske-no-data-icon"><FiFileText /></div>
                <p>No task records found</p>
                <p className="taske-no-data-subtext">
                  This employee has not been assigned any tasks yet.
                </p>
              </div>
            )}
          </div>
        );

      case "personal":
        return (
          <div className="perso-details-section">
            <div className="perso-section-header">
              <h4>
                <FiUser className="perso-header-icon" />
                Personal Information
              </h4>
              {personalData?.dateOfBirth && (
                <div className="perso-age-badge">
                  <FiCalendar className="perso-age-icon" />
                  <span className="perso-age-value">
                    {calculateAge(personalData.dateOfBirth)} years
                  </span>
                </div>
              )}
            </div>
            
            {personalData ? (
              <>
                {/* Family Information Card */}
                {(personalData.fatherName || personalData.motherName || personalData.spouseName) && (
                  <div className="perso-info-card">
                    <div className="perso-card-header">
                      <FiUsers className="perso-card-icon" />
                      <h5>Family Information</h5>
                    </div>
                    <div className="perso-card-content">
                      {personalData.fatherName && (
                        <div className="perso-info-row">
                          <div className="perso-info-label">
                            <FiUser className="perso-label-icon" />
                            <span>Father's Name</span>
                          </div>
                          <div className="perso-info-value">{personalData.fatherName}</div>
                        </div>
                      )}
                      
                      {personalData.motherName && (
                        <div className="perso-info-row">
                          <div className="perso-info-label">
                            <FiUser className="perso-label-icon" />
                            <span>Mother's Name</span>
                          </div>
                          <div className="perso-info-value">{personalData.motherName}</div>
                        </div>
                      )}
                      
                      {personalData.spouseName && (
                        <div className="perso-info-row">
                          <div className="perso-info-label">
                            <FiUsers className="perso-label-icon" />
                            <span>Spouse's Name</span>
                          </div>
                          <div className="perso-info-value">{personalData.spouseName}</div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                
                {/* Personal Details Card */}
                <div className="perso-info-card">
                  <div className="perso-card-header">
                    <FiInfo className="perso-card-icon" />
                    <h5>Personal Details</h5>
                  </div>
                  <div className="perso-card-content">
                    {personalData.dateOfBirth && (
                      <div className="perso-info-row">
                        <div className="perso-info-label">
                          <FiCalendar className="perso-label-icon" />
                          <span>Date of Birth</span>
                        </div>
                        <div className="perso-info-value">
                          <div className="perso-date-info">
                            <span className="perso-date">{new Date(personalData.dateOfBirth).toLocaleDateString('en-US', {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric'
                            })}</span>
                            <span className="perso-age">{calculateAge(personalData.dateOfBirth)} years</span>
                          </div>
                        </div>
                      </div>
                    )}
                    
                    {personalData.gender && (
                      <div className="perso-info-row">
                        <div className="perso-info-label">
                          <FaTransgender className="perso-label-icon" />
                          <span>Gender</span>
                        </div>
                        <div className="perso-info-value">
                          <span className="perso-gender-badge">
                            {personalData.gender}
                          </span>
                        </div>
                      </div>
                    )}
                    
                    {personalData.bloodGroup && (
                      <div className="perso-info-row">
                        <div className="perso-info-label">
                          <FiDroplet className="perso-label-icon" />
                          <span>Blood Group</span>
                        </div>
                        <div className="perso-info-value">
                          <span className="perso-blood-group">
                            {personalData.bloodGroup}
                          </span>
                        </div>
                      </div>
                    )}
                    
                    {personalData.nationality && (
                      <div className="perso-info-row">
                        <div className="perso-info-label">
                          <FiGlobe className="perso-label-icon" />
                          <span>Nationality</span>
                        </div>
                        <div className="perso-info-value">{personalData.nationality}</div>
                      </div>
                    )}
                    
                    {personalData.maritalStatus && (
                      <div className="perso-info-row">
                        <div className="perso-info-label">
                          <FiUsers className="perso-label-icon" />
                          <span>Marital Status</span>
                        </div>
                        <div className="perso-info-value">{personalData.maritalStatus}</div>
                      </div>
                    )}
                  </div>
                </div>
                
                {/* Contact Information Card */}
                {(personalData.address || personalData.emergencyContact || personalData.alternateMobile) && (
                  <div className="perso-info-card">
                    <div className="perso-card-header">
                      <FiPhone className="perso-card-icon" />
                      <h5>Contact Information</h5>
                    </div>
                    <div className="perso-card-content">
                      {personalData.address && (
                        <div className="perso-info-row">
                          <div className="perso-info-label">
                            <FiMapPin className="perso-label-icon" />
                            <span>Address</span>
                          </div>
                          <div className="perso-info-value perso-address">
                            {personalData.address}
                          </div>
                        </div>
                      )}
                      
                      {personalData.emergencyContact && (
                        <div className="perso-info-row">
                          <div className="perso-info-label">
                            <FiPhone className="perso-label-icon" />
                            <span>Emergency Contact</span>
                          </div>
                          <div className="perso-info-value">{personalData.emergencyContact}</div>
                        </div>
                      )}
                      
                      {personalData.alternateMobile && (
                        <div className="perso-info-row">
                          <div className="perso-info-label">
                            <FiPhone className="perso-label-icon" />
                            <span>Alternate Mobile</span>
                          </div>
                          <div className="perso-info-value">{personalData.alternateMobile}</div>
                        </div>
                      )}
                      
                      {personalData.personalEmail && (
                        <div className="perso-info-row">
                          <div className="perso-info-label">
                            <FiMail className="perso-label-icon" />
                            <span>Personal Email</span>
                          </div>
                          <div className="perso-info-value">{personalData.personalEmail}</div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                
                {/* Additional Information Card */}
                {(personalData.panNumber || personalData.aadhaarNumber || personalData.passportNumber) && (
                  <div className="perso-info-card">
                    <div className="perso-card-header">
                      <FaIdCard className="perso-card-icon" />
                      <h5>Identity Information</h5>
                    </div>
                    <div className="perso-card-content">
                      {personalData.panNumber && (
                        <div className="perso-info-row">
                          <div className="perso-info-label">
                            <FaIdCard className="perso-label-icon" />
                            <span>PAN Number</span>
                          </div>
                          <div className="perso-info-value">{personalData.panNumber}</div>
                        </div>
                      )}
                      
                      {personalData.aadhaarNumber && (
                        <div className="perso-info-row">
                          <div className="perso-info-label">
                            <FaIdCard className="perso-label-icon" />
                            <span>Aadhaar Number</span>
                          </div>
                          <div className="perso-info-value">{personalData.aadhaarNumber}</div>
                        </div>
                      )}
                      
                      {personalData.passportNumber && (
                        <div className="perso-info-row">
                          <div className="perso-info-label">
                            <FaPassport className="perso-label-icon" />
                            <span>Passport Number</span>
                          </div>
                          <div className="perso-info-value">{personalData.passportNumber}</div>
                        </div>
                      )}
                      
                      {personalData.drivingLicense && (
                        <div className="perso-info-row">
                          <div className="perso-info-label">
                            <FaCar className="perso-label-icon" />
                            <span>Driving License</span>
                          </div>
                          <div className="perso-info-value">{personalData.drivingLicense}</div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                
                {/* Summary Cards */}
                <div className="perso-summary-cards">
                  {personalData.dateOfBirth && (
                    <div className="perso-summary-card">
                      <div className="perso-summary-icon">
                        <FiCalendar />
                      </div>
                      <div className="perso-summary-content">
                        <h6>Age</h6>
                        <p>{calculateAge(personalData.dateOfBirth)} years</p>
                      </div>
                    </div>
                  )}
                  
                  {personalData.bloodGroup && (
                    <div className="perso-summary-card">
                      <div className="perso-summary-icon">
                        <FiDroplet />
                      </div>
                      <div className="perso-summary-content">
                        <h6>Blood Group</h6>
                        <p>{personalData.bloodGroup}</p>
                      </div>
                    </div>
                  )}
                  
                  {personalData.gender && (
                    <div className="perso-summary-card">
                      <div className="perso-summary-icon">
                        <FaTransgender />
                      </div>
                      <div className="perso-summary-content">
                        <h6>Gender</h6>
                        <p>{personalData.gender}</p>
                      </div>
                    </div>
                  )}
                  
                  {personalData.nationality && (
                    <div className="perso-summary-card">
                      <div className="perso-summary-icon">
                        <FiGlobe />
                      </div>
                      <div className="perso-summary-content">
                        <h6>Nationality</h6>
                        <p>{personalData.nationality}</p>
                      </div>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <div className="perso-empty-state">
                <div className="perso-empty-icon">
                  <FiUser />
                </div>
                <h5 className="perso-empty-title">No Personal Information Found</h5>
                <p className="perso-empty-text">
                  This employee's personal information has not been recorded yet.
                </p>
              </div>
            )}
          </div>
        );

      case "academic":
        return (
          <div className="acadi-details-section">
            <div className="acadi-section-header">
              <h4>
                <FaGraduationCap className="acadi-header-icon" />
                Academic Qualifications ({academicData.length || 0})
              </h4>
            </div>
            
            {academicData.length > 0 ? (
              <div className="acadi-qualification-list">
                {academicData.map((academic, index) => (
                  <div key={index} className="acadi-qualification-card">
                    <div className="acadi-card-header">
                      <div className="acadi-degree-info">
                        <h5 className="acadi-degree-title">
                          {academic.qualification || academic.degree || "Academic Qualification"}
                        </h5>
                        <div className="acadi-degree-year">
                          <span className="acadi-year-badge">
                            {academic.yearOfPassing || academic.year || "N/A"}
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="acadi-card-body">
                      <div className="acadi-info-grid">
                        <div className="acadi-info-item">
                          <span className="acadi-info-label">
                            <FaUniversity className="acadi-icon" />
                            Institution:
                          </span>
                          <span className="acadi-info-value">
                            {academic.university || academic.institution || "Not specified"}
                          </span>
                        </div>
                        
                        {academic.specialization && (
                          <div className="acadi-info-item">
                            <span className="acadi-info-label">
                              <FiTarget className="acadi-icon" />
                              Specialization:
                            </span>
                            <span className="acadi-info-value">{academic.specialization}</span>
                          </div>
                        )}
                        
                        {academic.grade && (
                          <div className="acadi-info-item">
                            <span className="acadi-info-label">
                              <FiStar className="acadi-icon" />
                              Grade:
                            </span>
                            <span className="acadi-info-value acadi-grade-value">
                              {academic.grade}
                            </span>
                          </div>
                        )}
                        
                        {academic.percentage && (
                          <div className="acadi-info-item">
                            <span className="acadi-info-label">
                              <FiBarChart className="acadi-icon" />
                              Percentage:
                            </span>
                            <span className="acadi-info-value acadi-percentage-value">
                              {academic.percentage}%
                            </span>
                          </div>
                        )}
                      </div>
                      
                      {/* Additional details section if needed */}
                      {(academic.marksheetNumber || academic.registrationNumber) && (
                        <div className="acadi-additional-info">
                          <div className="acadi-additional-grid">
                            {academic.marksheetNumber && (
                              <div className="acadi-additional-item">
                                <span className="acadi-additional-label">Marksheet No:</span>
                                <span className="acadi-additional-value">{academic.marksheetNumber}</span>
                              </div>
                            )}
                            {academic.registrationNumber && (
                              <div className="acadi-additional-item">
                                <span className="acadi-additional-label">Registration No:</span>
                                <span className="acadi-additional-value">{academic.registrationNumber}</span>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                    
                    <div className="acadi-card-footer">
                      <div className="acadi-qualification-level">
                        <span className={`acadi-level-badge ${getLevelClass(academic.qualification || academic.degree)}`}>
                          {getLevelText(academic.qualification || academic.degree)}
                        </span>
                      </div>
                      <div className="acadi-card-index">
                        <span className="acadi-index-number">#{index + 1}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="acadi-no-data">
                <div className="acadi-no-data-icon"><FaBook /></div>
                <p className="acadi-no-data-title">No Academic Records Found</p>
                <p className="acadi-no-data-subtext">
                  This employee has no academic qualifications recorded in the system.
                </p>
              </div>
            )}
          </div>
        );

      case "experience":
        return (
          <div className="expri-details-section">
            {/* Experience Modal Popup */}
            {expriShowModal && expriSelectedExp && (
              <div className="expri-modal-overlay" onClick={handleExpriCloseModal}>
                <div className="expri-modal" onClick={(e) => e.stopPropagation()}>
                  <div className="expri-modal-header">
                    <h3 className="expri-modal-title">
                      <FiBriefcase className="expri-modal-title-icon" />
                      Experience Details
                    </h3>
                    <button 
                      className="expri-modal-close-btn"
                      onClick={handleExpriCloseModal}
                    >
                      <FiX />
                    </button>
                  </div>
                  
                  <div className="expri-modal-content">
                    <div className="expri-modal-main">
                      <div className="expri-modal-company-info">
                        <h4 className="expri-modal-company-name">
                          {expriSelectedExp.companyName || expriSelectedExp.company || "Company Name"}
                        </h4>
                        <div className="expri-modal-company-badge">
                          <span className="expri-company-type">
                            {expriSelectedExp.companyType || "Corporate"}
                          </span>
                        </div>
                      </div>
                      
                      <div className="expri-modal-role-info">
                        <h5 className="expri-modal-role-title">
                          {expriSelectedExp.role || expriSelectedExp.position || "Role/Position"}
                        </h5>
                        <div className="expri-modal-duration">
                          <span className="expri-duration-badge">
                            {expriSelectedExp.startDate ? new Date(expriSelectedExp.startDate).toLocaleDateString('en-US', { 
                              month: 'short', 
                              year: 'numeric' 
                            }) : "Start Date"} - 
                            {expriSelectedExp.endDate ? new Date(expriSelectedExp.endDate).toLocaleDateString('en-US', { 
                              month: 'short', 
                              year: 'numeric' 
                            }) : "Present"}
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="expri-modal-details">
                      <div className="expri-details-grid">
                        {expriSelectedExp.location && (
                          <div className="expri-detail-item">
                            <span className="expri-detail-label">
                              <FiMapPin className="expri-detail-icon" />
                              Location:
                            </span>
                            <span className="expri-detail-value">{expriSelectedExp.location}</span>
                          </div>
                        )}
                        
                        {expriSelectedExp.employmentType && (
                          <div className="expri-detail-item">
                            <span className="expri-detail-label">
                              <FiBriefcase className="expri-detail-icon" />
                              Employment Type:
                            </span>
                            <span className="expri-detail-value expri-employment-type">
                              {expriSelectedExp.employmentType}
                            </span>
                          </div>
                        )}
                        
                        {expriSelectedExp.department && (
                          <div className="expri-detail-item">
                            <span className="expri-detail-label">
                              <FaBuilding className="expri-detail-icon" />
                              Department:
                            </span>
                            <span className="expri-detail-value">{expriSelectedExp.department}</span>
                          </div>
                        )}
                        
                        {expriSelectedExp.salary && (
                          <div className="expri-detail-item">
                            <span className="expri-detail-label">
                              <FiDollarSign className="expri-detail-icon" />
                              Salary:
                            </span>
                            <span className="expri-detail-value expri-salary">
                              {expriSelectedExp.salary}
                            </span>
                          </div>
                        )}
                      </div>
                      
                      {expriSelectedExp.description && (
                        <div className="expri-description-section">
                          <h6 className="expri-description-title">
                            <FiFileText className="expri-desc-icon" />
                            Role Description:
                          </h6>
                          <div className="expri-description-content">
                            {expriSelectedExp.description}
                          </div>
                        </div>
                      )}
                      
                      {expriSelectedExp.responsibilities && expriSelectedExp.responsibilities.length > 0 && (
                        <div className="expri-responsibilities-section">
                          <h6 className="expri-responsibilities-title">
                            <FiCheck className="expri-desc-icon" />
                            Key Responsibilities:
                          </h6>
                          <ul className="expri-responsibilities-list">
                            {expriSelectedExp.responsibilities.map((resp, index) => (
                              <li key={index} className="expri-responsibility-item">
                                <span className="expri-resp-bullet">•</span>
                                {resp}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                      
                      {expriSelectedExp.skills && expriSelectedExp.skills.length > 0 && (
                        <div className="expri-skills-section">
                          <h6 className="expri-skills-title">
                            <FiTool className="expri-desc-icon" />
                            Skills Used:
                          </h6>
                          <div className="expri-skills-list">
                            {expriSelectedExp.skills.map((skill, index) => (
                              <span key={index} className="expri-skill-tag">
                                {skill}
                              </span>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  
                  <div className="expri-modal-footer">
                    <button 
                      className="expri-modal-close-btn-main"
                      onClick={handleExpriCloseModal}
                    >
                      Close Details
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Main Experience Section */}
            <div className="expri-section-header">
              <div className="expri-header-content">
                <h4>
                  <FiBriefcase className="expri-header-icon" />
                  Work Experience ({experienceData.length || 0})
                </h4>
                <div className="expri-total-experience">
                  <span className="expri-total-badge">Total: {calculateTotalExperience()}</span>
                </div>
              </div>
            </div>
            
            {experienceData.length > 0 ? (
              <>
                <div className="expri-timeline-view">
                  {experienceData.map((exp, index) => {
                    const startDate = exp.startDate ? new Date(exp.startDate) : null;
                    const endDate = exp.endDate ? new Date(exp.endDate) : new Date();
                    const duration = startDate ? calculateDuration(startDate, endDate) : "N/A";
                    
                    return (
                      <div key={index} className="expri-timeline-card" onClick={() => handleExpriViewClick(exp)}>
                        <div className="expri-timeline-marker">
                          <div className="expri-marker-circle"></div>
                          {index < experienceData.length - 1 && (
                            <div className="expri-timeline-connector"></div>
                          )}
                        </div>
                        
                        <div className="expri-timeline-content">
                          <div className="expri-card-header">
                            <div className="expri-company-role">
                              <h5 className="expri-company-name">
                                {exp.companyName || exp.company || "Company"}
                              </h5>
                              <p className="expri-role-title">
                                {exp.role || exp.position || "Role"}
                              </p>
                            </div>
                            <div className="expri-duration-info">
                              <span className="expri-duration">
                                {duration}
                              </span>
                              <span className="expri-dates">
                                {exp.startDate ? new Date(exp.startDate).toLocaleDateString('en-US', { 
                                  month: 'short', 
                                  year: 'numeric' 
                                }) : "N/A"} - 
                                {exp.endDate ? new Date(exp.endDate).toLocaleDateString('en-US', { 
                                  month: 'short', 
                                  year: 'numeric' 
                                }) : "Present"}
                              </span>
                            </div>
                          </div>
                          
                          {exp.location && (
                            <div className="expri-location-info">
                              <FiMapPin className="expri-location-icon" />
                              <span className="expri-location-text">{exp.location}</span>
                            </div>
                          )}
                          
                          {exp.description && (
                            <div className="expri-description-preview">
                              <p className="expri-description-text">
                                {exp.description.length > 150 
                                  ? `${exp.description.substring(0, 150)}...` 
                                  : exp.description}
                              </p>
                            </div>
                          )}
                          
                          <div className="expri-card-footer">
                            <button className="expri-view-details-btn">
                              <FiEye /> View Details
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                
                <div className="expri-summary-footer">
                  <div className="expri-current-role">
                    {experienceData.length > 0 && (
                      <>
                        <span className="expri-current-label">Current Role:</span>
                        <span className="expri-current-value">
                          {experienceData[0].role || experienceData[0].position || "N/A"} at {experienceData[0].companyName || experienceData[0].company || "N/A"}
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </>
            ) : (
              <div className="expri-no-data">
                <div className="expri-no-data-icon"><FiBriefcase /></div>
                <p className="expri-no-data-title">No Work Experience Records Found</p>
                <p className="expri-no-data-subtext">
                  This employee has no work experience recorded in the system.
                </p>
              </div>
            )}
          </div>
        );

      case "documents":
        return (
          <div className="docui-details-section">
            {/* Document Details Modal */}
            {docuiShowModal && docuiSelectedDoc && (
              <div className="docui-modal-overlay" onClick={handleDocuiCloseModal}>
                <div className="docui-modal" onClick={(e) => e.stopPropagation()}>
                  <div className="docui-modal-header">
                    <h3 className="docui-modal-title">
                      {getDocumentIcon(docuiSelectedDoc)}
                      Document Details
                    </h3>
                    <button 
                      className="docui-modal-close-btn"
                      onClick={handleDocuiCloseModal}
                    >
                      <FiX />
                    </button>
                  </div>
                  
                  <div className="docui-modal-content">
                    <div className="docui-modal-document-preview">
                      <div className="docui-preview-icon" style={{ backgroundColor: `${getDocumentColor(docuiSelectedDoc)}20`, color: getDocumentColor(docuiSelectedDoc) }}>
                        {getDocumentIcon(docuiSelectedDoc)}
                      </div>
                      <div className="docui-preview-info">
                        <h4 className="docui-preview-title">{docuiSelectedDoc.name || "Untitled Document"}</h4>
                        <div className="docui-preview-badges">
                          <span className="docui-type-badge">{getFileType(docuiSelectedDoc.contentType, docuiSelectedDoc.filename)}</span>
                          <span className="docui-upload-badge">
                            {docuiSelectedDoc.uploadedVia === 'mobile' ? <FiPhone /> : <FiMonitor />}
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="docui-modal-details">
                      <div className="docui-details-grid">
                        <div className="docui-detail-item">
                          <span className="docui-detail-label"><FiFileText /> Document Name:</span>
                          <span className="docui-detail-value">{docuiSelectedDoc.name || "N/A"}</span>
                        </div>
                        
                        <div className="docui-detail-item">
                          <span className="docui-detail-label"><FiArchive /> File Size:</span>
                          <span className="docui-detail-value">{formatFileSize(docuiSelectedDoc.size)}</span>
                        </div>
                        
                        <div className="docui-detail-item">
                          <span className="docui-detail-label"><FiCalendar /> Uploaded Date:</span>
                          <span className="docui-detail-value">{formatDate(docuiSelectedDoc.uploadedAt)}</span>
                        </div>
                        
                        <div className="docui-detail-item">
                          <span className="docui-detail-label"><FiUser /> Uploaded By:</span>
                          <span className="docui-detail-value">{docuiSelectedDoc.uploadedBy || "Employee"}</span>
                        </div>
                        
                        <div className="docui-detail-item">
                          <span className="docui-detail-label"><FiUpload /> Upload Method:</span>
                          <span className="docui-detail-value docui-upload-method">
                            {docuiSelectedDoc.uploadedVia === 'mobile' ? 'Mobile App' : 'Web Portal'}
                          </span>
                        </div>
                        
                        <div className="docui-detail-item">
                          <span className="docui-detail-label"><FaIdCard /> Employee ID:</span>
                          <span className="docui-detail-value">
                            {docuiSelectedDoc.emp_id || currentEmpId || selectedEmployee?.emp_id || "N/A"}
                          </span>
                        </div>
                        
                        <div className="docui-detail-item">
                          <span className="docui-detail-label"><FiUser /> Employee Name:</span>
                          <span className="docui-detail-value">
                            {currentEmployeeName || selectedEmployee?.name || "N/A"}
                          </span>
                        </div>
                      </div>
                      
                      {docuiSelectedDoc.description && (
                        <div className="docui-description-section">
                          <h6 className="docui-description-title"><FiFileText /> Description:</h6>
                          <div className="docui-description-content">
                            {docuiSelectedDoc.description}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  
                  <div className="docui-modal-footer">
                    <div className="docui-modal-actions">
                      {docuiSelectedDoc.viewUrl && (
                        <button 
                          className="docui-action-btn docui-view-btn"
                          onClick={() => {
                            window.open(docuiSelectedDoc.viewUrl, '_blank', 'noopener,noreferrer');
                            handleDocuiCloseModal();
                          }}
                        >
                          <FiEye className="docui-btn-icon" />
                          View Document
                        </button>
                      )}
                      
                      {docuiSelectedDoc.downloadUrl && (
                        <button 
                          className="docui-action-btn docui-download-btn"
                          onClick={() => {
                            const link = document.createElement('a');
                            link.href = docuiSelectedDoc.downloadUrl;
                            link.download = docuiSelectedDoc.filename || `${docuiSelectedDoc.name}_${docuiSelectedDoc.emp_id}.pdf`;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            handleDocuiCloseModal();
                          }}
                        >
                          <FiDownload className="docui-btn-icon" />
                          Download
                        </button>
                      )}
                      
                      <button 
                        className="docui-action-btn docui-close-btn"
                        onClick={handleDocuiCloseModal}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Main Documents Section */}
            <div className="docui-section-header">
              <div className="docui-header-main">
                <h4>
                  <FiFileText className="docui-header-icon" />
                  Documents ({documentData.length || 0})
                </h4>
                <div className="docui-employee-info">
                  <span className="docui-employee-name">
                    <FiUser /> {currentEmployeeName || selectedEmployee?.name || "Employee"}
                  </span>
                  <span className="docui-employee-id">
                    <FaIdCard /> ID: {currentEmpId || selectedEmployee?.emp_id || "N/A"}
                  </span>
                </div>
              </div>
            </div>
            
            {documentData.length > 0 ? (
              <>
                <div className="docui-stats-container">
                  <div className="docui-stats-grid">
                    <div className="docui-stat-card">
                      <div className="docui-stat-icon">
                        <FiFileText />
                      </div>
                      <div className="docui-stat-content">
                        <h5>Total Documents</h5>
                        <p className="docui-stat-number">{documentData.length}</p>
                      </div>
                    </div>
                    
                    <div className="docui-stat-card">
                      <div className="docui-stat-icon">
                        <FiPhone />
                      </div>
                      <div className="docui-stat-content">
                        <h5>Mobile Uploads</h5>
                        <p className="docui-stat-number">
                          {documentData.filter(doc => doc.uploadedVia === 'mobile').length}
                        </p>
                      </div>
                    </div>
                    
                    <div className="docui-stat-card">
                      <div className="docui-stat-icon">
                        <FiMonitor />
                      </div>
                      <div className="docui-stat-content">
                        <h5>Desktop Uploads</h5>
                        <p className="docui-stat-number">
                          {documentData.filter(doc => doc.uploadedVia === 'web').length}
                        </p>
                      </div>
                    </div>
                    
                    <div className="docui-stat-card">
                      <div className="docui-stat-icon">
                        <FiArchive />
                      </div>
                      <div className="docui-stat-content">
                        <h5>Total Size</h5>
                        <p className="docui-stat-number">
                          {formatFileSize(documentData.reduce((total, doc) => total + (doc.size || 0), 0))}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="docui-documents-gridd">
                  {documentData.map((doc, index) => (
                    <div key={doc._id || index} className="docui-document-cards">
                      <div className="docui-cards-header" style={{ borderLeftColor: getDocumentColor(doc) }}>
                        <div className="docui-document-icon" style={{ backgroundColor: `${getDocumentColor(doc)}20`, color: getDocumentColor(doc) }}>
                          {getDocumentIcon(doc)}
                        </div>
                        <div className="docui-document-badges">
                          <span className="docui-upload-badge">
                            {doc.uploadedVia === 'mobile' ? <FiPhone /> : <FiMonitor />}
                          </span>
                          {doc.size > 1024 * 1024 && (
                            <span className="docui-size-badge"><FiArchive /> Large</span>
                          )}
                        </div>
                      </div>
                      
                      <div className="docui-card-content">
                        <h5 className="docui-document-title" title={doc.name}>
                          {doc.name || "Untitled Document"}
                        </h5>
                        
                        <div className="docui-document-meta">
                          <div className="docui-meta-item">
                            <FiCalendar className="docui-meta-icon" />
                            <span className="docui-meta-text">{formatDate(doc.uploadedAt)}</span>
                          </div>
                          
                          {doc.size > 0 && (
                            <div className="docui-meta-item">
                              <FiArchive className="docui-meta-icon" />
                              <span className="docui-meta-text">{formatFileSize(doc.size)}</span>
                            </div>
                          )}
                          
                          <div className="docui-meta-item">
                            <FiFileText className="docui-meta-icon" />
                            <span className="docui-meta-text">{getFileType(doc.contentType, doc.filename)}</span>
                          </div>
                        </div>
                        
                        <div className="docui-card-actions">
                          <button 
                            className="docui-action-btn docui-view-details-btn"
                            onClick={() => handleDocuiViewClick(doc)}
                            title="View Details"
                          >
                            <FiEye className="docui-action-icon" />
                            Details
                          </button>
                          
                          {doc.viewUrl && (
                            <button 
                              className="docui-action-btn docui-preview-btn"
                              onClick={() => window.open(doc.viewUrl, '_blank', 'noopener,noreferrer')}
                              title="Preview Document"
                            >
                              <FiSearch className="docui-action-icon" />
                              Preview
                            </button>
                          )}
                          
                          {doc.downloadUrl && (
                            <button 
                              className="docui-action-btn docui-download-btn"
                              onClick={() => {
                                const link = document.createElement('a');
                                link.href = doc.downloadUrl;
                                link.download = doc.filename || `${doc.name}_${doc.emp_id || currentEmpId}.pdf`;
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                              }}
                              title="Download Document"
                            >
                              <FiDownload className="docui-action-icon" />
                              Download
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                
                <div className="docui-quick-actions">
                  <button 
                    className="docui-quick-action-btn docui-upload-btn"
                    onClick={() => {
                      const event = new CustomEvent('openDocumentUpload', {
                        detail: { 
                          emp_id: currentEmpId || selectedEmployee?.emp_id, 
                          employeeName: currentEmployeeName || selectedEmployee?.name 
                        }
                      });
                      window.dispatchEvent(event);
                    }}
                  >
                    <FiUpload className="docui-action-icon" />
                    Upload New Document
                  </button>
                  
                  <button 
                    className="docui-quick-action-btn docui-export-btn"
                    onClick={() => {
                      const csvContent = [
                        ['Document Name', 'Type', 'Size', 'Upload Date', 'Employee ID', 'Employee Name', 'Upload Method'],
                        ...documentData.map(doc => [
                          doc.name,
                          getFileType(doc.contentType, doc.filename),
                          formatFileSize(doc.size),
                          formatDate(doc.uploadedAt),
                          doc.emp_id || currentEmpId || selectedEmployee?.emp_id,
                          currentEmployeeName || selectedEmployee?.name,
                          doc.uploadedVia === 'mobile' ? 'Mobile App' : 'Web Portal'
                        ])
                      ].map(row => row.join(',')).join('\n');
                      
                      const blob = new Blob([csvContent], { type: 'text/csv' });
                      const url = window.URL.createObjectURL(blob);
                      const a = document.createElement('a');
                      a.href = url;
                      a.download = `documents_${currentEmpId || selectedEmployee?.emp_id}_${new Date().toISOString().split('T')[0]}.csv`;
                      document.body.appendChild(a);
                      a.click();
                      document.body.removeChild(a);
                      window.URL.revokeObjectURL(url);
                    }}
                  >
                    <FiBarChart className="docui-action-icon" />
                    Export to CSV
                  </button>
                </div>
              </>
            ) : (
              <div className="docui-empty-state">
                <div className="docui-empty-icon"><FiFileText /></div>
                <h5 className="docui-empty-title">No Documents Found</h5>
                <p className="docui-empty-text">
                  This employee has no documents uploaded yet. Upload documents to keep track of important files.
                </p>
                {currentEmpId && (
                  <button 
                    className="docui-empty-action-btn"
                    onClick={() => {
                      const event = new CustomEvent('openDocumentUpload', {
                        detail: { 
                          emp_id: currentEmpId, 
                          employeeName: currentEmployeeName || selectedEmployee?.name 
                        }
                      });
                      window.dispatchEvent(event);
                    }}
                  >
                    <FiUpload className="docui-btn-icon" />
                    Upload First Document
                  </button>
                )}
              </div>
            )}
          </div>
        );

      default:
        return <p>Select a tab to view details</p>;
    }
  };

  return (
    <div className="employee-details-page">
      {/* Header */}
      <div className="details-header">
        <div>
          <h2><FiUser /> Employee Details</h2>
          <p>View complete employee information</p>
        </div>
        <div className="header-actions">
          <button className="refresh-btn" onClick={fetchEmployees}>
            <FiRefreshCw /> Refresh
          </button>
          {onBack && (
            <button className="back-btn" onClick={onBack}>
              <FiArrowLeft /> Back
            </button>
          )}
        </div>
      </div>

      <div className="details-main-container">
        {/* Left Panel - Employee List */}
        <div className="employee-list-container">
          <div className="list-header">
            <h3>Employees ({employees.length})</h3>
            <input
              type="text"
              placeholder={<><FiSearch /> Search employees...</>}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="search-box"
            />
          </div>

          <div className="employee-scroll-list">
            {loading ? (
              <div className="loading">Loading employees...</div>
            ) : filteredEmployees.length === 0 ? (
              <div className="no-data">No employees found</div>
            ) : (
              filteredEmployees.map(emp => {
                // Check profile picture from both sources
                const profilePicFromEmployee = emp.profilePicture || emp.profilePic || emp.photo;
                const profilePicFromMap = employeeProfilePics[emp._id];
                
                // Use profile picture from map (fetched separately) if available, otherwise from employee data
                const avatarUrl = profilePicFromMap || 
                  (profilePicFromEmployee ? 
                    (profilePicFromEmployee.startsWith('http') || profilePicFromEmployee.startsWith('data:')) ? 
                      profilePicFromEmployee : 
                      `${API_BASE_URL}${profilePicFromEmployee}` 
                    : null
                  );
                
                console.log(`Employee ${emp.name} - Avatar URL:`, avatarUrl); // Debug log
                
                return (
                  <div
                    key={emp._id}
                    className={`employee-list-item ${
                      selectedEmployee?._id === emp._id ? "selected" : ""
                    }`}
                    onClick={() => setSelectedEmployee(emp)}
                  >
                    <div className="item-avatar">
                      {avatarUrl ? (
                        <>
                          <img 
                            src={avatarUrl} 
                            alt={emp.name}
                            className="employee-avatar-img"
                            onError={(e) => {
                              console.error(`Failed to load image for ${emp.name}:`, e);
                              e.target.style.display = 'none';
                              // Show initials if image fails
                              const initialsDiv = e.target.parentElement.querySelector('.avatar-initials');
                              if (initialsDiv) initialsDiv.style.display = 'flex';
                            }}
                            onLoad={() => {
                              // Hide initials when image loads successfully
                              const initialsDiv = document.querySelector(`[data-emp-id="${emp._id}"] .avatar-initials`);
                              if (initialsDiv) initialsDiv.style.display = 'none';
                            }}
                          />
                          <div className="avatar-initials" data-emp-id={emp._id}>
                            {emp.name ? emp.name.charAt(0).toUpperCase() : 'E'}
                          </div>
                        </>
                      ) : (
                        <div className="avatar-initials">
                          {emp.name ? emp.name.charAt(0).toUpperCase() : 'E'}
                        </div>
                      )}
                    </div>
                    <div className="item-info">
                      <h4>{emp.name}</h4>
                      <p>{emp.department} • {emp.role}</p>
                      <small>ID: {emp.emp_id}</small>
                    </div>
                    <div className="item-status">
                      <span className={`status ${emp.status}`}>
                        {emp.status || "Active"}
                      </span>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>

        {/* Right Panel - Employee Details */}
        <div className="employee-details-container">
          {selectedEmployee ? (
            <>
              <div className="employee-header">
                <div className="header-left">
                  <div className="emp-avatar-large">
                    {(() => {
                      // Check multiple sources for profile picture
                      const profilePicFromEmployee = selectedEmployee.profilePicture || 
                                                   selectedEmployee.profilePic || 
                                                   selectedEmployee.photo;
                      const profilePicFromMap = employeeProfilePics[selectedEmployee._id];
                      
                      const avatarUrl = profilePicFromMap || 
                        (profilePicFromEmployee ? 
                          (profilePicFromEmployee.startsWith('http') || profilePicFromEmployee.startsWith('data:')) ? 
                            profilePicFromEmployee : 
                            `${API_BASE_URL}${profilePicFromEmployee}` 
                          : null
                        );
                      
                      console.log(`Selected employee ${selectedEmployee.name} - Avatar URL:`, avatarUrl); // Debug log
                      
                      return (
                        <>
                          {avatarUrl ? (
                            <>
                              <img 
                                src={avatarUrl} 
                                alt={selectedEmployee.name}
                                className="employee-avatar-large-img"
                                onError={(e) => {
                                  console.error(`Failed to load large image for ${selectedEmployee.name}:`, e);
                                  e.target.style.display = 'none';
                                  // Show initials if image fails
                                  const initialsDiv = e.target.parentElement.querySelector('.avatar-large-initials');
                                  if (initialsDiv) initialsDiv.style.display = 'flex';
                                }}
                                onLoad={() => {
                                  // Hide initials when image loads successfully
                                  const initialsDiv = document.querySelector('.avatar-large-initials');
                                  if (initialsDiv) initialsDiv.style.display = 'none';
                                }}
                              />
                              <div className="avatar-large-initials">
                                {selectedEmployee.name ? selectedEmployee.name.charAt(0).toUpperCase() : 'E'}
                              </div>
                            </>
                          ) : (
                            <div className="avatar-large-initials">
                              {selectedEmployee.name ? selectedEmployee.name.charAt(0).toUpperCase() : 'E'}
                            </div>
                          )}
                        </>
                      );
                    })()}
                  </div>
                  <div>
                    <h3>{selectedEmployee.name}</h3>
                    <p>
                      {selectedEmployee.role} • {selectedEmployee.department} • 
                      ID: {selectedEmployee.emp_id}
                    </p>
                  </div>
                </div>
                <div className="header-right">
                  <button 
                    className="edit-btn"
                    onClick={() => navigate(`/onboardingpage?edit=${selectedEmployee._id}`)}
                  >
                    <FiEdit /> Edit
                  </button>
                  <button 
                    className="dashboard-btn"
                    onClick={() => navigate(`/dashboard`)}
                  >
                    <FiGrid /> Dashboard
                  </button>
                </div>
              </div>
              
              {/* Tabs */}
              <div className="details-tabs">
                {["basic", "leaves", "attendance", "timesheet", "tasks", "personal", "academic", "experience", "documents"].map(tab => (
                  <button
                    key={tab}
                    className={`tab-btn ${activeTab === tab ? "active" : ""}`}
                    onClick={() => setActiveTab(tab)}
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </button>
                ))}
              </div>

              {/* Tab Content */}
              <div className="tab-content">
                {loadingDetails ? (
                  <div className="loading">Loading details...</div>
                ) : (
                  renderTabContent()
                )}
              </div>
            </>
          ) : (
            <div className="no-selection">
              <div className="select-icon"><FiArrowLeft /></div>
              <h4>Select an Employee</h4>
              <p>Choose an employee from the list to view their complete details</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmployeeDetails;